export const trainingPlans = [
  {
    id: 'half-marathon-16-weeks-vi',
    name: 'Kế Hoạch Luyện Tập Half Marathon',
    description: 'Kế hoạch luyện tập chuyên nghiệp 16 tuần với tiến độ có cấu trúc',
    duration: 16,
    distance: '21.1km',
    targetTime: '1:45-2:30',
    language: 'vi',
    type: 'half-marathon',
    weeks: [
      {
        week: 1,
        focus: 'Xây Dựng Nền Tảng',
        totalDistance: '25km',
        monday: {

          type: 'Rest/Cross-Training',

          description: 'Active recovery or cross-training',

          intensity: 'Recovery',

          metrics: {

            duration: '30-45 min'

          },

          notes: 'Swimming'

        },
        tuesday: {
          type: 'Easy Run',
          description: 'Easy pace run - Zone 2 effort',
          intensity: 'Easy',
          metrics: {
            distance: '5km',
            pace: '6:00-6:30/km',
            duration: '30-35 min'
          },
          notes: 'Conversational pace, build aerobic base'
        },
        wednesday: {
          type: 'Interval',
          description: '4x400m intervals with 90s rest',
          intensity: 'Hard',
          metrics: {
            distance: '4km',
            pace: '4:30-5:00/km',
            duration: '25-30 min'
          },
          notes: 'Focus on form, controlled breathing'
        },
        thursday: {
          type: 'Easy Run',
          description: 'Recovery run - Zone 2 effort',
          intensity: 'Easy',
          metrics: {
            distance: '5km',
            pace: '6:00-6:30/km',
            duration: '30-35 min'
          },
          notes: 'Very easy pace, active recovery'
        },
        friday: {
          type: 'Rest',
          description: 'Complete rest day',
          intensity: 'Rest',
          metrics: {
            duration: '0 min'
          },
          notes: 'Recovery and preparation for long run'
        },
        saturday: {
          type: 'Long Run',
          description: 'Long slow distance run - Zone 2 effort',
          intensity: 'Moderate',
          metrics: {
            distance: '8km',
            pace: '6:15-6:45/km',
            duration: '50-55 min'
          },
          notes: 'Build endurance, practice race nutrition'
        },
        sunday: {
          type: 'Easy Run',
          description: 'Recovery run - Zone 1-2 effort',
          intensity: 'Easy',
          metrics: {
            distance: '3km',
            pace: '6:30-7:00/km',
            duration: '20-25 min'
          },
          notes: 'Very easy pace, active recovery'
        }
      },
      {
        week: 2,
        focus: 'Endurance Building',
        totalDistance: '28km',
        monday: {

          type: 'Rest/Cross-Training',

          description: 'Active recovery or cross-training',

          intensity: 'Recovery',

          metrics: {

            duration: '30-45 min'

          },

          notes: 'Swimming'

        },
        tuesday: {

          type: 'Easy Run',

          description: 'Easy pace run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '5km',

            pace: '6:00-6:30/km',

            duration: '30-35 min'

          },

          notes: 'Conversational pace'

        },
        wednesday: {

          type: 'Interval',

          description: '4x400m intervals with 90s rest',

          intensity: 'Hard',

          metrics: {

            distance: '4km',

            pace: '4:30-5:00/km',

            duration: '25-30 min'

          },

          notes: 'Focus on form'

        },
        thursday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '5km',

            pace: '6:00-6:30/km',

            duration: '30-35 min'

          },

          notes: 'Very easy pace'

        },
        friday: {

          type: 'Rest',

          description: 'Complete rest day',

          intensity: 'Rest',

          metrics: {

            duration: '0 min'

          },

          notes: 'Recovery and preparation for long run'

        },
        saturday: {

          type: 'Long Run',

          description: 'Long slow distance run - Zone 2 effort',

          intensity: 'Moderate',

          metrics: {

            distance: '10km',

            pace: '6:15-6:45/km',

            duration: '60-65 min'

          },

          notes: 'Build endurance'

        },
        sunday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 1-2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '3km',

            pace: '6:30-7:00/km',

            duration: '20-25 min'

          },

          notes: 'Very easy pace'

        }
      },
      {
        week: 3,
        focus: 'Endurance Building',
        totalDistance: '32km',
        monday: {

          type: 'Rest/Cross-Training',

          description: 'Active recovery or cross-training',

          intensity: 'Recovery',

          metrics: {

            duration: '30-45 min'

          },

          notes: 'Swimming'

        },
        tuesday: {

          type: 'Easy Run',

          description: 'Easy pace run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '6km',

            pace: '6:00-6:30/km',

            duration: '35-40 min'

          },

          notes: 'Conversational pace'

        },
        wednesday: {

          type: 'Tempo Run',

          description: '15 min tempo at half marathon pace',

          intensity: 'Hard',

          metrics: {

            distance: '6km',

            pace: '5:30-6:00/km',

            duration: '35-40 min'

          },

          notes: 'Include 10 min warm-up and cool-down'

        },
        thursday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '5km',

            pace: '6:00-6:30/km',

            duration: '30-35 min'

          },

          notes: 'Very easy pace'

        },
        friday: {

          type: 'Rest',

          description: 'Complete rest day',

          intensity: 'Rest',

          metrics: {

            duration: '0 min'

          },

          notes: 'Recovery and preparation for long run'

        },
        saturday: {

          type: 'Long Run',

          description: 'Long slow distance run - Zone 2 effort',

          intensity: 'Moderate',

          metrics: {

            distance: '10km',

            pace: '6:15-6:45/km',

            duration: '60-65 min'

          },

          notes: 'Build endurance'

        },
        sunday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 1-2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '4km',

            pace: '6:30-7:00/km',

            duration: '25-30 min'

          },

          notes: 'Very easy pace'

        }
      },
      {
        week: 4,
        focus: 'Endurance Building',
        totalDistance: '35km',
        monday: {

          type: 'Rest/Cross-Training',

          description: 'Active recovery or cross-training',

          intensity: 'Recovery',

          metrics: {

            duration: '30-45 min'

          },

          notes: 'Swimming'

        },
        tuesday: {

          type: 'Easy Run',

          description: 'Easy pace run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '6km',

            pace: '6:00-6:30/km',

            duration: '35-40 min'

          },

          notes: 'Conversational pace'

        },
        wednesday: {

          type: 'Interval',

          description: '5x400m intervals with 90s rest',

          intensity: 'Hard',

          metrics: {

            distance: '5km',

            pace: '4:30-5:00/km',

            duration: '30-35 min'

          },

          notes: 'Focus on form'

        },
        thursday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '5km',

            pace: '6:00-6:30/km',

            duration: '30-35 min'

          },

          notes: 'Very easy pace'

        },
        friday: {

          type: 'Rest',

          description: 'Complete rest day',

          intensity: 'Rest',

          metrics: {

            duration: '0 min'

          },

          notes: 'Recovery and preparation for long run'

        },
        saturday: {

          type: 'Long Run',

          description: 'Long slow distance run - Zone 2 effort',

          intensity: 'Moderate',

          metrics: {

            distance: '12km',

            pace: '6:15-6:45/km',

            duration: '70-75 min'

          },

          notes: 'Build endurance'

        },
        sunday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 1-2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '4km',

            pace: '6:30-7:00/km',

            duration: '25-30 min'

          },

          notes: 'Very easy pace'

        }
      },
      {
        week: 5,
        focus: 'Endurance Building',
        totalDistance: '38km',
        monday: {

          type: 'Rest/Cross-Training',

          description: 'Active recovery or cross-training',

          intensity: 'Recovery',

          metrics: {

            duration: '30-45 min'

          },

          notes: 'Swimming'

        },
        tuesday: {

          type: 'Easy Run',

          description: 'Easy pace run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '7km',

            pace: '6:00-6:30/km',

            duration: '40-45 min'

          },

          notes: 'Conversational pace'

        },
        wednesday: {

          type: 'Tempo Run',

          description: '20 min tempo at half marathon pace',

          intensity: 'Hard',

          metrics: {

            distance: '7km',

            pace: '5:30-6:00/km',

            duration: '40-45 min'

          },

          notes: 'Include 10 min warm-up and cool-down'

        },
        thursday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '6km',

            pace: '6:00-6:30/km',

            duration: '35-40 min'

          },

          notes: 'Very easy pace'

        },
        friday: {

          type: 'Rest',

          description: 'Complete rest day',

          intensity: 'Rest',

          metrics: {

            duration: '0 min'

          },

          notes: 'Recovery and preparation for long run'

        },
        saturday: {

          type: 'Long Run',

          description: 'Long slow distance run - Zone 2 effort',

          intensity: 'Moderate',

          metrics: {

            distance: '13km',

            pace: '6:15-6:45/km',

            duration: '75-80 min'

          },

          notes: 'Build endurance'

        },
        sunday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 1-2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '5km',

            pace: '6:30-7:00/km',

            duration: '30-35 min'

          },

          notes: 'Very easy pace'

        }
      },
      {
        week: 6,
        focus: 'Endurance Building',
        totalDistance: '42km',
        monday: {

          type: 'Rest/Cross-Training',

          description: 'Active recovery or cross-training',

          intensity: 'Recovery',

          metrics: {

            duration: '30-45 min'

          },

          notes: 'Swimming'

        },
        tuesday: {

          type: 'Easy Run',

          description: 'Easy pace run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '7km',

            pace: '6:00-6:30/km',

            duration: '40-45 min'

          },

          notes: 'Conversational pace'

        },
        wednesday: {

          type: 'Interval',

          description: '6x400m intervals with 90s rest',

          intensity: 'Hard',

          metrics: {

            distance: '6km',

            pace: '4:30-5:00/km',

            duration: '35-40 min'

          },

          notes: 'Focus on form'

        },
        thursday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '6km',

            pace: '6:00-6:30/km',

            duration: '35-40 min'

          },

          notes: 'Very easy pace'

        },
        friday: {

          type: 'Rest',

          description: 'Complete rest day',

          intensity: 'Rest',

          metrics: {

            duration: '0 min'

          },

          notes: 'Recovery and preparation for long run'

        },
        saturday: {

          type: 'Long Run',

          description: 'Long slow distance run - Zone 2 effort',

          intensity: 'Moderate',

          metrics: {

            distance: '15km',

            pace: '6:15-6:45/km',

            duration: '85-90 min'

          },

          notes: 'Build endurance'

        },
        sunday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 1-2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '5km',

            pace: '6:30-7:00/km',

            duration: '30-35 min'

          },

          notes: 'Very easy pace'

        }
      },
      {
        week: 7,
        focus: 'Endurance Building',
        totalDistance: '45km',
        monday: {

          type: 'Rest/Cross-Training',

          description: 'Active recovery or cross-training',

          intensity: 'Recovery',

          metrics: {

            duration: '30-45 min'

          },

          notes: 'Swimming'

        },
        tuesday: {

          type: 'Easy Run',

          description: 'Easy pace run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '8km',

            pace: '6:00-6:30/km',

            duration: '45-50 min'

          },

          notes: 'Conversational pace'

        },
        wednesday: {

          type: 'Tempo Run',

          description: '25 min tempo at half marathon pace',

          intensity: 'Hard',

          metrics: {

            distance: '8km',

            pace: '5:30-6:00/km',

            duration: '45-50 min'

          },

          notes: 'Include 10 min warm-up and cool-down'

        },
        thursday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '7km',

            pace: '6:00-6:30/km',

            duration: '40-45 min'

          },

          notes: 'Very easy pace'

        },
        friday: {

          type: 'Rest',

          description: 'Complete rest day',

          intensity: 'Rest',

          metrics: {

            duration: '0 min'

          },

          notes: 'Recovery and preparation for long run'

        },
        saturday: {

          type: 'Long Run',

          description: 'Long slow distance run - Zone 2 effort',

          intensity: 'Moderate',

          metrics: {

            distance: '16km',

            pace: '6:15-6:45/km',

            duration: '90-95 min'

          },

          notes: 'Build endurance'

        },
        sunday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 1-2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '6km',

            pace: '6:30-7:00/km',

            duration: '35-40 min'

          },

          notes: 'Very easy pace'

        }
      },
      {
        week: 8,
        focus: 'Endurance Building',
        totalDistance: '48km',
        monday: {

          type: 'Rest/Cross-Training',

          description: 'Active recovery or cross-training',

          intensity: 'Recovery',

          metrics: {

            duration: '30-45 min'

          },

          notes: 'Swimming'

        },
        tuesday: {

          type: 'Easy Run',

          description: 'Easy pace run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '8km',

            pace: '6:00-6:30/km',

            duration: '45-50 min'

          },

          notes: 'Conversational pace'

        },
        wednesday: {

          type: 'Interval',

          description: '8x400m intervals with 90s rest',

          intensity: 'Hard',

          metrics: {

            distance: '7km',

            pace: '4:30-5:00/km',

            duration: '40-45 min'

          },

          notes: 'Focus on form'

        },
        thursday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '7km',

            pace: '6:00-6:30/km',

            duration: '40-45 min'

          },

          notes: 'Very easy pace'

        },
        friday: {

          type: 'Rest',

          description: 'Complete rest day',

          intensity: 'Rest',

          metrics: {

            duration: '0 min'

          },

          notes: 'Recovery and preparation for long run'

        },
        saturday: {

          type: 'Long Run',

          description: 'Long slow distance run - Zone 2 effort',

          intensity: 'Moderate',

          metrics: {

            distance: '17km',

            pace: '6:15-6:45/km',

            duration: '95-100 min'

          },

          notes: 'Build endurance'

        },
        sunday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 1-2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '6km',

            pace: '6:30-7:00/km',

            duration: '35-40 min'

          },

          notes: 'Very easy pace'

        }
      },
      {
        week: 9,
        focus: 'Endurance Building',
        totalDistance: '50km',
        monday: {

          type: 'Rest/Cross-Training',

          description: 'Active recovery or cross-training',

          intensity: 'Recovery',

          metrics: {

            duration: '30-45 min'

          },

          notes: 'Swimming'

        },
        tuesday: {

          type: 'Easy Run',

          description: 'Easy pace run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '9km',

            pace: '6:00-6:30/km',

            duration: '50-55 min'

          },

          notes: 'Conversational pace'

        },
        wednesday: {

          type: 'Tempo Run',

          description: '30 min tempo at half marathon pace',

          intensity: 'Hard',

          metrics: {

            distance: '9km',

            pace: '5:30-6:00/km',

            duration: '50-55 min'

          },

          notes: 'Include 10 min warm-up and cool-down'

        },
        thursday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '8km',

            pace: '6:00-6:30/km',

            duration: '45-50 min'

          },

          notes: 'Very easy pace'

        },
        friday: {

          type: 'Rest',

          description: 'Complete rest day',

          intensity: 'Rest',

          metrics: {

            duration: '0 min'

          },

          notes: 'Recovery and preparation for long run'

        },
        saturday: {

          type: 'Long Run',

          description: 'Long slow distance run - Zone 2 effort',

          intensity: 'Moderate',

          metrics: {

            distance: '18km',

            pace: '6:15-6:45/km',

            duration: '100-105 min'

          },

          notes: 'Build endurance'

        },
        sunday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 1-2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '6km',

            pace: '6:30-7:00/km',

            duration: '35-40 min'

          },

          notes: 'Very easy pace'

        }
      },
      {
        week: 10,
        focus: 'Endurance Building',
        totalDistance: '52km',
        monday: {

          type: 'Rest/Cross-Training',

          description: 'Active recovery or cross-training',

          intensity: 'Recovery',

          metrics: {

            duration: '30-45 min'

          },

          notes: 'Swimming'

        },
        tuesday: {

          type: 'Easy Run',

          description: 'Easy pace run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '9km',

            pace: '6:00-6:30/km',

            duration: '50-55 min'

          },

          notes: 'Conversational pace'

        },
        wednesday: {

          type: 'Interval',

          description: '10x400m intervals with 90s rest',

          intensity: 'Hard',

          metrics: {

            distance: '8km',

            pace: '4:30-5:00/km',

            duration: '45-50 min'

          },

          notes: 'Focus on form'

        },
        thursday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '8km',

            pace: '6:00-6:30/km',

            duration: '45-50 min'

          },

          notes: 'Very easy pace'

        },
        friday: {

          type: 'Rest',

          description: 'Complete rest day',

          intensity: 'Rest',

          metrics: {

            duration: '0 min'

          },

          notes: 'Recovery and preparation for long run'

        },
        saturday: {

          type: 'Long Run',

          description: 'Long slow distance run - Zone 2 effort',

          intensity: 'Moderate',

          metrics: {

            distance: '19km',

            pace: '6:15-6:45/km',

            duration: '105-110 min'

          },

          notes: 'Build endurance'

        },
        sunday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 1-2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '7km',

            pace: '6:30-7:00/km',

            duration: '40-45 min'

          },

          notes: 'Very easy pace'

        }
      },
      {
        week: 11,
        focus: 'Endurance Building',
        totalDistance: '55km',
        monday: {

          type: 'Rest/Cross-Training',

          description: 'Active recovery or cross-training',

          intensity: 'Recovery',

          metrics: {

            duration: '30-45 min'

          },

          notes: 'Swimming'

        },
        tuesday: {

          type: 'Easy Run',

          description: 'Easy pace run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '10km',

            pace: '6:00-6:30/km',

            duration: '55-60 min'

          },

          notes: 'Conversational pace'

        },
        wednesday: {

          type: 'Tempo Run',

          description: '35 min tempo at half marathon pace',

          intensity: 'Hard',

          metrics: {

            distance: '10km',

            pace: '5:30-6:00/km',

            duration: '55-60 min'

          },

          notes: 'Include 10 min warm-up and cool-down'

        },
        thursday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '9km',

            pace: '6:00-6:30/km',

            duration: '50-55 min'

          },

          notes: 'Very easy pace'

        },
        friday: {

          type: 'Rest',

          description: 'Complete rest day',

          intensity: 'Rest',

          metrics: {

            duration: '0 min'

          },

          notes: 'Recovery and preparation for long run'

        },
        saturday: {

          type: 'Long Run',

          description: 'Long slow distance run - Zone 2 effort',

          intensity: 'Moderate',

          metrics: {

            distance: '20km',

            pace: '6:15-6:45/km',

            duration: '110-115 min'

          },

          notes: 'Build endurance'

        },
        sunday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 1-2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '7km',

            pace: '6:30-7:00/km',

            duration: '40-45 min'

          },

          notes: 'Very easy pace'

        }
      },
      {
        week: 12,
        focus: 'Endurance Building',
        totalDistance: '58km',
        monday: {

          type: 'Rest/Cross-Training',

          description: 'Active recovery or cross-training',

          intensity: 'Recovery',

          metrics: {

            duration: '30-45 min'

          },

          notes: 'Swimming'

        },
        tuesday: {

          type: 'Easy Run',

          description: 'Easy pace run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '10km',

            pace: '6:00-6:30/km',

            duration: '55-60 min'

          },

          notes: 'Conversational pace'

        },
        wednesday: {

          type: 'Interval',

          description: '12x400m intervals with 90s rest',

          intensity: 'Hard',

          metrics: {

            distance: '9km',

            pace: '4:30-5:00/km',

            duration: '50-55 min'

          },

          notes: 'Focus on form'

        },
        thursday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '9km',

            pace: '6:00-6:30/km',

            duration: '50-55 min'

          },

          notes: 'Very easy pace'

        },
        friday: {

          type: 'Rest',

          description: 'Complete rest day',

          intensity: 'Rest',

          metrics: {

            duration: '0 min'

          },

          notes: 'Recovery and preparation for long run'

        },
        saturday: {

          type: 'Long Run',

          description: 'Long slow distance run - Zone 2 effort',

          intensity: 'Moderate',

          metrics: {

            distance: '21km',

            pace: '6:15-6:45/km',

            duration: '115-120 min'

          },

          notes: 'Build endurance'

        },
        sunday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 1-2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '8km',

            pace: '6:30-7:00/km',

            duration: '45-50 min'

          },

          notes: 'Very easy pace'

        }
      },
      {
        week: 13,
        focus: 'Endurance Building',
        totalDistance: '60km',
        monday: {

          type: 'Rest/Cross-Training',

          description: 'Active recovery or cross-training',

          intensity: 'Recovery',

          metrics: {

            duration: '30-45 min'

          },

          notes: 'Swimming'

        },
        tuesday: {

          type: 'Easy Run',

          description: 'Easy pace run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '11km',

            pace: '6:00-6:30/km',

            duration: '60-65 min'

          },

          notes: 'Conversational pace'

        },
        wednesday: {

          type: 'Tempo Run',

          description: '40 min tempo at half marathon pace',

          intensity: 'Hard',

          metrics: {

            distance: '11km',

            pace: '5:30-6:00/km',

            duration: '60-65 min'

          },

          notes: 'Include 10 min warm-up and cool-down'

        },
        thursday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '10km',

            pace: '6:00-6:30/km',

            duration: '55-60 min'

          },

          notes: 'Very easy pace'

        },
        friday: {

          type: 'Rest',

          description: 'Complete rest day',

          intensity: 'Rest',

          metrics: {

            duration: '0 min'

          },

          notes: 'Recovery and preparation for long run'

        },
        saturday: {

          type: 'Long Run',

          description: 'Long slow distance run - Zone 2 effort',

          intensity: 'Moderate',

          metrics: {

            distance: '22km',

            pace: '6:15-6:45/km',

            duration: '120-125 min'

          },

          notes: 'Build endurance'

        },
        sunday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 1-2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '8km',

            pace: '6:30-7:00/km',

            duration: '45-50 min'

          },

          notes: 'Very easy pace'

        }
      },
      {
        week: 14,
        focus: 'Endurance Building',
        totalDistance: '62km',
        monday: {

          type: 'Rest/Cross-Training',

          description: 'Active recovery or cross-training',

          intensity: 'Recovery',

          metrics: {

            duration: '30-45 min'

          },

          notes: 'Swimming'

        },
        tuesday: {

          type: 'Easy Run',

          description: 'Easy pace run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '11km',

            pace: '6:00-6:30/km',

            duration: '60-65 min'

          },

          notes: 'Conversational pace'

        },
        wednesday: {

          type: 'Interval',

          description: '14x400m intervals with 90s rest',

          intensity: 'Hard',

          metrics: {

            distance: '10km',

            pace: '4:30-5:00/km',

            duration: '55-60 min'

          },

          notes: 'Focus on form'

        },
        thursday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '10km',

            pace: '6:00-6:30/km',

            duration: '55-60 min'

          },

          notes: 'Very easy pace'

        },
        friday: {

          type: 'Rest',

          description: 'Complete rest day',

          intensity: 'Rest',

          metrics: {

            duration: '0 min'

          },

          notes: 'Recovery and preparation for long run'

        },
        saturday: {

          type: 'Long Run',

          description: 'Long slow distance run - Zone 2 effort',

          intensity: 'Moderate',

          metrics: {

            distance: '23km',

            pace: '6:15-6:45/km',

            duration: '125-130 min'

          },

          notes: 'Build endurance'

        },
        sunday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 1-2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '8km',

            pace: '6:30-7:00/km',

            duration: '45-50 min'

          },

          notes: 'Very easy pace'

        }
      },
      {
        week: 15,
        focus: 'Tapering',
        totalDistance: '45km',
        monday: {

          type: 'Rest/Cross-Training',

          description: 'Active recovery or cross-training',

          intensity: 'Recovery',

          metrics: {

            duration: '30-45 min'

          },

          notes: 'Swimming'

        },
        tuesday: {

          type: 'Easy Run',

          description: 'Easy pace run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '8km',

            pace: '6:00-6:30/km',

            duration: '45-50 min'

          },

          notes: 'Conversational pace'

        },
        wednesday: {

          type: 'Tempo Run',

          description: '15 min tempo at half marathon pace',

          intensity: 'Moderate',

          metrics: {

            distance: '7km',

            pace: '5:30-6:00/km',

            duration: '40-45 min'

          },

          notes: 'Include 10 min warm-up and cool-down'

        },
        thursday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '8km',

            pace: '6:00-6:30/km',

            duration: '45-50 min'

          },

          notes: 'Very easy pace'

        },
        friday: {

          type: 'Rest',

          description: 'Complete rest day',

          intensity: 'Rest',

          metrics: {

            duration: '0 min'

          },

          notes: 'Recovery and preparation for long run'

        },
        saturday: {

          type: 'Long Run',

          description: 'Long slow distance run - Zone 2 effort',

          intensity: 'Moderate',

          metrics: {

            distance: '12km',

            pace: '6:15-6:45/km',

            duration: '65-70 min'

          },

          notes: 'Final long run'

        },
        sunday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 1-2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '6km',

            pace: '6:30-7:00/km',

            duration: '35-40 min'

          },

          notes: 'Very easy pace'

        }
      },
      {
        week: 16,
        focus: 'Race Week',
        totalDistance: '25km',
        monday: {

          type: 'Easy Run',

          description: 'Very easy pace run',

          intensity: 'Easy',

          metrics: {

            distance: '4km',

            pace: '6:30-7:00/km',

            duration: '25-30 min'

          },

          notes: 'Very easy pace'

        },
        tuesday: {

          type: 'Easy Run',

          description: 'Easy pace run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '5km',

            pace: '6:00-6:30/km',

            duration: '30-35 min'

          },

          notes: 'Conversational pace'

        },
        wednesday: {

          type: 'Easy Run',

          description: 'Very easy pace run',

          intensity: 'Easy',

          metrics: {

            distance: '3km',

            pace: '6:30-7:00/km',

            duration: '20-25 min'

          },

          notes: 'Very easy pace'

        },
        thursday: {

          type: 'Rest',

          description: 'Complete rest day',

          intensity: 'Rest',

          metrics: {

            duration: '0 min'

          },

          notes: 'Recovery and preparation for race'

        },
        friday: {

          type: 'Easy Run',

          description: 'Very easy pace run',

          intensity: 'Easy',

          metrics: {

            distance: '3km',

            pace: '6:30-7:00/km',

            duration: '20-25 min'

          },

          notes: 'Very easy pace'

        },
        saturday: {

          type: 'Rest',

          description: 'Complete rest day',

          intensity: 'Rest',

          metrics: {

            duration: '0 min'

          },

          notes: 'Rest and prepare for race day'

        },
        sunday: {

          type: 'Race Day',

          description: 'Half Marathon Race',

          intensity: 'Race',

          metrics: {

            distance: '21.1km',

            pace: 'Race pace',

            duration: '1:45-2:30'

          },

          notes: 'Race day! Trust your training and enjoy the experience'

        }
      }
    ]
  },
  {
    id: 'full-marathon-16-weeks-vi',
    name: 'Kế Hoạch Luyện Tập Full Marathon',
    description: 'Kế hoạch luyện tập toàn diện 16 tuần chuẩn bị marathon',
    duration: 16,
    distance: '42.2km',
    targetTime: '3:30-5:00',
    language: 'vi',
    type: 'full-marathon',
    weeks: [
      {
        week: 1,
        focus: 'Xây dựng nền tảng',
        totalDistance: '35km',
        monday: {
          type: 'Nghỉ ngơi/Hoạt động chéo',
          description: 'Hồi phục tích cực hoặc tập luyện chéo',
          intensity: 'Hồi phục',
          metrics: {
            duration: '30-45 min'
          },
          notes: 'Bơi lội'
        },
        tuesday: {
          type: 'Chạy nhẹ',
          description: 'Chạy nhịp độ nhẹ - Cường độ Zone 2',
          intensity: 'Nhẹ',
          metrics: {
            distance: '6km',
            pace: '6:00-6:30/km',
            duration: '35-40 min'
          },
          notes: 'Nhịp độ trò chuyện'
        },
        wednesday: {
          type: 'Chạy biến tốc',
          description: '5 lần chạy 400m với 90 giây nghỉ',
          intensity: 'Nặng',
          metrics: {
            distance: '5km',
            pace: '4:30-5:00/km',
            duration: '30-35 min'
          },
          notes: 'Tập trung vào kỹ thuật'
        },
        thursday: {
          type: 'Chạy nhẹ',
          description: 'Chạy hồi phục - Cường độ Zone 2',
          intensity: 'Nhẹ',
          metrics: {
            distance: '6km',
            pace: '6:00-6:30/km',
            duration: '35-40 min'
          },
          notes: 'Nhịp độ rất nhẹ'
        },
        friday: {
          type: 'Nghỉ ngơi',
          description: 'Ngày nghỉ hoàn toàn',
          intensity: 'Nghỉ ngơi',
          metrics: {
            duration: '0 min'
          },
          notes: 'Hồi phục và chuẩn bị cho buổi chạy dài'
        },
        saturday: {
          type: 'Chạy dài',
          description: 'Chạy dài với tốc độ chậm - Cường độ Zone 2',
          intensity: 'Trung bình',
          metrics: {
            distance: '10km',
            pace: '6:15-6:45/km',
            duration: '60-65 min'
          },
          notes: 'Tăng cường sức bền'
        },
        sunday: {
          type: 'Chạy nhẹ',
          description: 'Chạy hồi phục - Cường độ Zone 1-2',
          intensity: 'Nhẹ',
          metrics: {
            distance: '4km',
            pace: '6:30-7:00/km',
            duration: '25-30 min'
          },
          notes: 'Nhịp độ rất nhẹ'
        }
      },
      {
        week: 2,
        focus: 'Tăng cường sức bền',
        totalDistance: '40km',
        monday: {
          type: 'Nghỉ ngơi/Hoạt động chéo',
          description: 'Hồi phục tích cực hoặc tập luyện chéo',
          intensity: 'Hồi phục',
          metrics: {
            duration: '30-45 min'
          },
          notes: 'Bơi lội'
        },
        tuesday: {
          type: 'Chạy nhẹ',
          description: 'Chạy nhịp độ nhẹ - Cường độ Zone 2',
          intensity: 'Nhẹ',
          metrics: {
            distance: '6km',
            pace: '6:00-6:30/km',
            duration: '35-40 min'
          },
          notes: 'Nhịp độ trò chuyện'
        },
        wednesday: {
          type: 'Chạy biến tốc',
          description: '5 lần chạy 400m với 90 giây nghỉ',
          intensity: 'Nặng',
          metrics: {
            distance: '5km',
            pace: '4:30-5:00/km',
            duration: '30-35 min'
          },
          notes: 'Tập trung vào kỹ thuật'
        },
        thursday: {
          type: 'Chạy nhẹ',
          description: 'Chạy hồi phục - Cường độ Zone 2',
          intensity: 'Nhẹ',
          metrics: {
            distance: '6km',
            pace: '6:00-6:30/km',
            duration: '35-40 min'
          },
          notes: 'Nhịp độ rất nhẹ'
        },
        friday: {
          type: 'Nghỉ ngơi',
          description: 'Ngày nghỉ hoàn toàn',
          intensity: 'Nghỉ ngơi',
          metrics: {
            duration: '0 min'
          },
          notes: 'Hồi phục và chuẩn bị cho buổi chạy dài'
        },
        saturday: {
          type: 'Chạy dài',
          description: 'Chạy dài với tốc độ chậm - Cường độ Zone 2',
          intensity: 'Trung bình',
          metrics: {
            distance: '12km',
            pace: '6:15-6:45/km',
            duration: '70-75 min'
          },
          notes: 'Tăng cường sức bền'
        },
        sunday: {
          type: 'Chạy nhẹ',
          description: 'Chạy hồi phục - Cường độ Zone 1-2',
          intensity: 'Nhẹ',
          metrics: {
            distance: '4km',
            pace: '6:30-7:00/km',
            duration: '25-30 min'
          },
          notes: 'Nhịp độ rất nhẹ'
        }
      },
      {
        week: 3,
        focus: 'Tăng cường sức bền',
        totalDistance: '45km',
        monday: {
          type: 'Nghỉ ngơi/Hoạt động chéo',
          description: 'Hồi phục tích cực hoặc tập luyện chéo',
          intensity: 'Hồi phục',
          metrics: {
            duration: '30-45 min'
          },
          notes: 'Bơi lội'
        },
        tuesday: {
          type: 'Chạy nhẹ',
          description: 'Chạy nhịp độ nhẹ - Cường độ Zone 2',
          intensity: 'Nhẹ',
          metrics: {
            distance: '8km',
            pace: '6:00-6:30/km',
            duration: '45-50 min'
          },
          notes: 'Nhịp độ trò chuyện'
        },
        wednesday: {
          type: 'Chạy tempo',
          description: 'Chạy tempo 20 min ở nhịp độ bán marathon',
          intensity: 'Nặng',
          metrics: {
            distance: '8km',
            pace: '5:30-6:00/km',
            duration: '40-45 min'
          },
          notes: 'Bao gồm 10 min khởi động và giãn cơ'
        },
        thursday: {
          type: 'Chạy nhẹ',
          description: 'Chạy hồi phục - Cường độ Zone 2',
          intensity: 'Nhẹ',
          metrics: {
            distance: '6km',
            pace: '6:00-6:30/km',
            duration: '35-40 min'
          },
          notes: 'Nhịp độ rất nhẹ'
        },
        friday: {
          type: 'Nghỉ ngơi',
          description: 'Ngày nghỉ hoàn toàn',
          intensity: 'Nghỉ ngơi',
          metrics: {
            duration: '0 min'
          },
          notes: 'Hồi phục và chuẩn bị cho buổi chạy dài'
        },
        saturday: {
          type: 'Chạy dài',
          description: 'Chạy dài với tốc độ chậm - Cường độ Zone 2',
          intensity: 'Trung bình',
          metrics: {
            distance: '14km',
            pace: '6:15-6:45/km',
            duration: '80-85 min'
          },
          notes: 'Tăng cường sức bền'
        },
        sunday: {
          type: 'Chạy nhẹ',
          description: 'Chạy hồi phục - Cường độ Zone 1-2',
          intensity: 'Nhẹ',
          metrics: {
            distance: '4km',
            pace: '6:30-7:00/km',
            duration: '25-30 min'
          },
          notes: 'Nhịp độ rất nhẹ'
        }
      },
      {
        week: 4,
        focus: 'Tăng cường sức bền',
        totalDistance: '50km',
        monday: {
          type: 'Nghỉ ngơi/Hoạt động chéo',
          description: 'Hồi phục tích cực hoặc tập luyện chéo',
          intensity: 'Hồi phục',
          metrics: {
            duration: '30-45 min'
          },
          notes: 'Bơi lội hoặc đạp xe'
        },
        tuesday: {
          type: 'Chạy nhẹ',
          description: 'Chạy nhịp độ nhẹ - Cường độ Zone 2',
          intensity: 'Nhẹ',
          metrics: {
            distance: '8km',
            pace: '6:00-6:30/km',
            duration: '45-50 min'
          },
          notes: 'Nhịp độ trò chuyện'
        },
        wednesday: {
          type: 'Chạy biến tốc',
          description: '6 lần chạy 400m với 90 giây nghỉ',
          intensity: 'Nặng',
          metrics: {
            distance: '6km',
            pace: '4:30-5:00/km',
            duration: '35-40 min'
          },
          notes: 'Tập trung vào kỹ thuật'
        },
        thursday: {
          type: 'Chạy nhẹ',
          description: 'Chạy hồi phục - Cường độ Zone 2',
          intensity: 'Nhẹ',
          metrics: {
            distance: '6km',
            pace: '6:00-6:30/km',
            duration: '35-40 min'
          },
          notes: 'Nhịp độ rất nhẹ'
        },
        friday: {
          type: 'Nghỉ ngơi',
          description: 'Ngày nghỉ hoàn toàn',
          intensity: 'Nghỉ ngơi',
          metrics: {
            duration: '0 min'
          },
          notes: 'Hồi phục và chuẩn bị cho buổi chạy dài'
        },
        saturday: {
          type: 'Chạy dài',
          description: 'Chạy dài với tốc độ chậm - Cường độ Zone 2',
          intensity: 'Trung bình',
          metrics: {
            distance: '16km',
            pace: '6:15-6:45/km',
            duration: '90-95 min'
          },
          notes: 'Tăng cường sức bền'
        },
        sunday: {
          type: 'Chạy nhẹ',
          description: 'Chạy hồi phục - Cường độ Zone 1-2',
          intensity: 'Nhẹ',
          metrics: {
            distance: '6km',
            pace: '6:30-7:00/km',
            duration: '35-40 min'
          },
          notes: 'Nhịp độ rất nhẹ'
        }
      },
      {
        week: 5,
        focus: 'Tăng cường sức bền',
        totalDistance: '55km',
        monday: {
          type: 'Nghỉ ngơi/Hoạt động chéo',
          description: 'Hồi phục tích cực hoặc tập luyện chéo',
          intensity: 'Hồi phục',
          metrics: {
            duration: '30-45 min'
          },
          notes: 'Bơi lội hoặc đạp xe'
        },
        tuesday: {
          type: 'Chạy nhẹ',
          description: 'Chạy nhịp độ nhẹ - Cường độ Zone 2',
          intensity: 'Nhẹ',
          metrics: {
            distance: '8km',
            pace: '6:00-6:30/km',
            duration: '45-50 min'
          },
          notes: 'Nhịp độ trò chuyện'
        },
        wednesday: {
          type: 'Chạy tempo',
          description: 'Chạy tempo 25 min ở nhịp độ bán marathon',
          intensity: 'Nặng',
          metrics: {
            distance: '10km',
            pace: '5:30-6:00/km',
            duration: '50-55 min'
          },
          notes: 'Bao gồm 10 min khởi động và giãn cơ'
        },
        thursday: {
          type: 'Chạy nhẹ',
          description: 'Chạy hồi phục - Cường độ Zone 2',
          intensity: 'Nhẹ',
          metrics: {
            distance: '6km',
            pace: '6:00-6:30/km',
            duration: '35-40 min'
          },
          notes: 'Nhịp độ rất nhẹ'
        },
        friday: {
          type: 'Nghỉ ngơi',
          description: 'Ngày nghỉ hoàn toàn',
          intensity: 'Nghỉ ngơi',
          metrics: {
            duration: '0 min'
          },
          notes: 'Hồi phục và chuẩn bị cho buổi chạy dài'
        },
        saturday: {
          type: 'Chạy dài',
          description: 'Chạy dài với tốc độ chậm - Cường độ Zone 2',
          intensity: 'Trung bình',
          metrics: {
            distance: '18km',
            pace: '6:15-6:45/km',
            duration: '100-105 min'
          },
          notes: 'Tăng cường sức bền'
        },
        sunday: {
          type: 'Chạy nhẹ',
          description: 'Chạy hồi phục - Cường độ Zone 1-2',
          intensity: 'Nhẹ',
          metrics: {
            distance: '5km',
            pace: '6:30-7:00/km',
            duration: '30-35 min'
          },
          notes: 'Nhịp độ rất nhẹ'
        }
      },
      {
        week: 6,
        focus: 'Tăng cường sức bền',
        totalDistance: '60km',
        monday: {
          type: 'Nghỉ ngơi/Hoạt động chéo',
          description: 'Hồi phục tích cực hoặc tập luyện chéo',
          intensity: 'Hồi phục',
          metrics: {
            duration: '30-45 min'
          },
          notes: 'Bơi lội hoặc đạp xe'
        },
        tuesday: {
          type: 'Chạy nhẹ',
          description: 'Chạy nhịp độ nhẹ - Cường độ Zone 2',
          intensity: 'Nhẹ',
          metrics: {
            distance: '10km',
            pace: '6:00-6:30/km',
            duration: '55-60 min'
          },
          notes: 'Nhịp độ trò chuyện'
        },
        wednesday: {
          type: 'Chạy biến tốc',
          description: '8 lần chạy 400m với 90 giây nghỉ',
          intensity: 'Nặng',
          metrics: {
            distance: '8km',
            pace: '4:30-5:00/km',
            duration: '40-45 min'
          },
          notes: 'Tập trung vào kỹ thuật'
        },
        thursday: {
          type: 'Chạy nhẹ',
          description: 'Chạy hồi phục - Cường độ Zone 2',
          intensity: 'Nhẹ',
          metrics: {
            distance: '8km',
            pace: '6:00-6:30/km',
            duration: '45-50 min'
          },
          notes: 'Nhịp độ rất nhẹ'
        },
        friday: {
          type: 'Nghỉ ngơi',
          description: 'Ngày nghỉ hoàn toàn',
          intensity: 'Nghỉ ngơi',
          metrics: {
            duration: '0 min'
          },
          notes: 'Hồi phục và chuẩn bị cho buổi chạy dài'
        },
        saturday: {
          type: 'Chạy dài',
          description: 'Chạy dài với tốc độ chậm - Cường độ Zone 2',
          intensity: 'Trung bình',
          metrics: {
            distance: '20km',
            pace: '6:15-6:45/km',
            duration: '110-115 min'
          },
          notes: 'Tăng cường sức bền'
        },
        sunday: {
          type: 'Chạy nhẹ',
          description: 'Chạy hồi phục - Cường độ Zone 1-2',
          intensity: 'Nhẹ',
          metrics: {
            distance: '6km',
            pace: '6:30-7:00/km',
            duration: '35-40 min'
          },
          notes: 'Nhịp độ rất nhẹ'
        }
      },
      {
        week: 7,
        focus: 'Tăng cường sức bền',
        totalDistance: '65km',
        monday: {
          type: 'Nghỉ ngơi/Hoạt động chéo',
          description: 'Hồi phục tích cực hoặc tập luyện chéo',
          intensity: 'Hồi phục',
          metrics: {
            duration: '30-45 min'
          },
          notes: 'Bơi lội hoặc đạp xe'
        },
        tuesday: {
          type: 'Chạy nhẹ',
          description: 'Chạy nhịp độ nhẹ - Cường độ Zone 2',
          intensity: 'Nhẹ',
          metrics: {
            distance: '10km',
            pace: '6:00-6:30/km',
            duration: '55-60 min'
          },
          notes: 'Nhịp độ trò chuyện'
        },
        wednesday: {
          type: 'Chạy tempo',
          description: 'Chạy tempo 30 min ở nhịp độ bán marathon',
          intensity: 'Nặng',
          metrics: {
            distance: '12km',
            pace: '5:30-6:00/km',
            duration: '60-65 min'
          },
          notes: 'Bao gồm 10 min khởi động và giãn cơ'
        },
        thursday: {
          type: 'Chạy nhẹ',
          description: 'Chạy hồi phục - Cường độ Zone 2',
          intensity: 'Nhẹ',
          metrics: {
            distance: '8km',
            pace: '6:00-6:30/km',
            duration: '45-50 min'
          },
          notes: 'Nhịp độ rất nhẹ'
        },
        friday: {
          type: 'Nghỉ ngơi',
          description: 'Ngày nghỉ hoàn toàn',
          intensity: 'Nghỉ ngơi',
          metrics: {
            duration: '0 min'
          },
          notes: 'Hồi phục và chuẩn bị cho buổi chạy dài'
        },
        saturday: {
          type: 'Chạy dài',
          description: 'Chạy dài với tốc độ chậm - Cường độ Zone 2',
          intensity: 'Trung bình',
          metrics: {
            distance: '22km',
            pace: '6:15-6:45/km',
            duration: '120-125 min'
          },
          notes: 'Tăng cường sức bền'
        },
        sunday: {
          type: 'Chạy nhẹ',
          description: 'Chạy hồi phục - Cường độ Zone 1-2',
          intensity: 'Nhẹ',
          metrics: {
            distance: '7km',
            pace: '6:30-7:00/km',
            duration: '40-45 min'
          },
          notes: 'Nhịp độ rất nhẹ'
        }
      },
      {
        week: 8,
        focus: 'Tăng cường sức bền',
        totalDistance: '70km',
        monday: {
          type: 'Nghỉ ngơi/Hoạt động chéo',
          description: 'Hồi phục tích cực hoặc tập luyện chéo',
          intensity: 'Hồi phục',
          metrics: {
            duration: '30-45 min'
          },
          notes: 'Bơi lội hoặc đạp xe'
        },
        tuesday: {
          type: 'Chạy nhẹ',
          description: 'Chạy nhịp độ nhẹ - Cường độ Zone 2',
          intensity: 'Nhẹ',
          metrics: {
            distance: '12km',
            pace: '6:00-6:30/km',
            duration: '65-70 min'
          },
          notes: 'Nhịp độ trò chuyện'
        },
        wednesday: {
          type: 'Chạy biến tốc',
          description: '10 lần chạy 400m với 90 giây nghỉ',
          intensity: 'Nặng',
          metrics: {
            distance: '10km',
            pace: '4:30-5:00/km',
            duration: '45-50 min'
          },
          notes: 'Tập trung vào kỹ thuật'
        },
        thursday: {
          type: 'Chạy nhẹ',
          description: 'Chạy hồi phục - Cường độ Zone 2',
          intensity: 'Nhẹ',
          metrics: {
            distance: '8km',
            pace: '6:00-6:30/km',
            duration: '45-50 minutes'
          },
          notes: 'Nhịp độ rất nhẹ'
        },
        friday: {
          type: 'Nghỉ ngơi',
          description: 'Ngày nghỉ hoàn toàn',
          intensity: 'Nghỉ ngơi',
          metrics: {
            duration: '0 min'
          },
          notes: 'Hồi phục và chuẩn bị cho buổi chạy dài'
        },
        saturday: {
          type: 'Chạy dài',
          description: 'Chạy dài với tốc độ chậm - Cường độ Zone 2',
          intensity: 'Trung bình',
          metrics: {
            distance: '24km',
            pace: '6:15-6:45/km',
            duration: '130-135 min'
          },
          notes: 'Tăng cường sức bền'
        },
        sunday: {
          type: 'Chạy nhẹ',
          description: 'Chạy hồi phục - Cường độ Zone 1-2',
          intensity: 'Nhẹ',
          metrics: {
            distance: '8km',
            pace: '6:30-7:00/km',
            duration: '45-50 minutes'
          },
          notes: 'Nhịp độ rất nhẹ'
        }
      },
      {
        week: 9,
        focus: 'Tăng cường sức bền',
        totalDistance: '75km',
        monday: {
          type: 'Nghỉ ngơi/Hoạt động chéo',
          description: 'Hồi phục tích cực hoặc tập luyện chéo',
          intensity: 'Hồi phục',
          metrics: {
            duration: '30-45 minutes'
          },
          notes: 'Bơi lội hoặc đạp xe'
        },
        tuesday: {
          type: 'Chạy nhẹ',
          description: 'Chạy nhịp độ nhẹ - Cường độ Zone 2',
          intensity: 'Nhẹ',
          metrics: {
            distance: '12km',
            pace: '6:00-6:30/km',
            duration: '65-70 minutes'
          },
          notes: 'Nhịp độ trò chuyện'
        },
        wednesday: {
          type: 'Chạy tempo',
          description: 'Chạy tempo 35 min ở nhịp độ bán marathon',
          intensity: 'Nặng',
          metrics: {
            distance: '14km',
            pace: '5:30-6:00',
            duration: '70-75 minutes'
          },
          notes: 'Bao gồm 10 min khởi động và giãn cơ'
        },
        thursday: {
          type: 'Chạy nhẹ',
          description: 'Chạy hồi phục - Cường độ Zone 2',
          intensity: 'Nhẹ',
          metrics: {
            distance: '8km',
            pace: '6:00-6:30/km',
            duration: '45-50 min'
          },
          notes: 'Nhịp độ rất nhẹ'
        },
        friday: {
          type: 'Nghỉ ngơi',
          description: 'Ngày nghỉ hoàn toàn',
          intensity: 'Nghỉ ngơi',
          metrics: {
            duration: '0 min'
          },
          notes: 'Hồi phục và chuẩn bị cho buổi chạy dài'
        },
        saturday: {
          type: 'Chạy dài',
          description: 'Chạy dài với tốc độ chậm - Cường độ Zone 2',
          intensity: 'Trung bình',
          metrics: {
            distance: '26km',
            pace: '6:15-6:45/km',
            duration: '140-145 min'
          },
          notes: 'Tăng cường sức bền'
        },
        sunday: {
          type: 'Chạy nhẹ',
          description: 'Chạy hồi phục - Cường độ Zone 1-2',
          intensity: 'Nhẹ',
          metrics: {
            distance: '9km',
            pace: '6:30-7:00/km',
            duration: '50-55 min'
          },
          notes: 'Nhịp độ rất nhẹ'
        }
      },
      {
        week: 10,
        focus: 'Tăng cường sức bền',
        totalDistance: '80km',
        monday: {
          type: 'Nghỉ ngơi/Hoạt động chéo',
          description: 'Hồi phục tích cực hoặc tập luyện chéo',
          intensity: 'Hồi phục',
          metrics: {
            duration: '30-45 min'
          },
          notes: 'Bơi lội hoặc đạp xe'
        },
        tuesday: {
          type: 'Chạy nhẹ',
          description: 'Chạy nhịp độ nhẹ - Cường độ Zone 2',
          intensity: 'Nhẹ',
          metrics: {
            distance: '12km',
            pace: '6:00-6:30/km',
            duration: '65-70 min'
          },
          notes: 'Nhịp độ trò chuyện'
        },
        wednesday: {
          type: 'Chạy biến tốc',
          description: '12 lần chạy 400m với 90 giây nghỉ',
          intensity: 'Nặng',
          metrics: {
            distance: '12km',
            pace: '4:30-5:00/km',
            duration: '50-55 min'
          },
          notes: 'Tập trung vào kỹ thuật'
        },
        thursday: {
          type: 'Chạy nhẹ',
          description: 'Chạy hồi phục - Cường độ Zone 2',
          intensity: 'Nhẹ',
          metrics: {
            distance: '10km',
            pace: '6:00-6:30/km',
            duration: '55-60 min'
          },
          notes: 'Nhịp độ rất nhẹ'
        },
        friday: {
          type: 'Nghỉ ngơi',
          description: 'Ngày nghỉ hoàn toàn',
          intensity: 'Nghỉ ngơi',
          metrics: {
            duration: '0 min'
          },
          notes: 'Hồi phục và chuẩn bị cho buổi chạy dài'
        },
        saturday: {
          type: 'Chạy dài',
          description: 'Chạy dài với tốc độ chậm - Cường độ Zone 2',
          intensity: 'Trung bình',
          metrics: {
            distance: '28km',
            pace: '6:15-6:45/km',
            duration: '150-155 min'
          },
          notes: 'Tăng cường sức bền'
        },
        sunday: {
          type: 'Chạy nhẹ',
          description: 'Chạy hồi phục - Cường độ Zone 1-2',
          intensity: 'Nhẹ',
          metrics: {
            distance: '10km',
            pace: '6:30-7:00/km',
            duration: '55-60 min'
          },
          notes: 'Nhịp độ rất nhẹ'
        }
      },
      {
        week: 11,
        focus: 'Tăng cường sức bền',
        totalDistance: '85km',
        monday: {
          type: 'Nghỉ ngơi/Hoạt động chéo',
          description: 'Hồi phục tích cực hoặc tập luyện chéo',
          intensity: 'Hồi phục',
          metrics: {
            duration: '30-45 min'
          },
          notes: 'Bơi lội hoặc đạp xe'
        },
        tuesday: {
          type: 'Chạy nhẹ',
          description: 'Chạy nhịp độ nhẹ - Cường độ Zone 2',
          intensity: 'Nhẹ',
          metrics: {
            distance: '12km',
            pace: '6:00-6:30/km',
            duration: '65-70 min'
          },
          notes: 'Nhịp độ trò chuyện'
        },
        wednesday: {
          type: 'Chạy tempo',
          description: 'Chạy tempo 40 min ở nhịp độ bán marathon',
          intensity: 'Nặng',
          metrics: {
            distance: '16km',
            pace: '5:30-6:00/km',
            duration: '80-85 min'
          },
          notes: 'Bao gồm 10 min khởi động và giãn cơ'
        },
        thursday: {
          type: 'Chạy nhẹ',
          description: 'Chạy hồi phục - Cường độ Zone 2',
          intensity: 'Nhẹ',
          metrics: {
            distance: '10km',
            pace: '6:00-6:30/km',
            duration: '55-60 min'
          },
          notes: 'Nhịp độ rất nhẹ'
        },
        friday: {
          type: 'Nghỉ ngơi',
          description: 'Ngày nghỉ hoàn toàn',
          intensity: 'Nghỉ ngơi',
          metrics: {
            duration: '0 min'
          },
          notes: 'Hồi phục và chuẩn bị cho buổi chạy dài'
        },
        saturday: {
          type: 'Chạy dài',
          description: 'Chạy dài với tốc độ chậm - Cường độ Zone 2',
          intensity: 'Trung bình',
          metrics: {
            distance: '30km',
            pace: '6:15-6:45/km',
            duration: '160-165 min'
          },
          notes: 'Tăng cường sức bền'
        },
        sunday: {
          type: 'Chạy nhẹ',
          description: 'Chạy hồi phục - Cường độ Zone 1-2',
          intensity: 'Nhẹ',
          metrics: {
            distance: '10km',
            pace: '6:30-7:00/km',
            duration: '55-60 min'
          },
          notes: 'Nhịp độ rất nhẹ'
        }
      },
      {
        week: 12,
        focus: 'Tăng cường sức bền',
        totalDistance: '90km',
        monday: {
          type: 'Nghỉ ngơi/Hoạt động chéo',
          description: 'Hồi phục tích cực hoặc tập luyện chéo',
          intensity: 'Hồi phục',
          metrics: {
            duration: '30-45 min'
          },
          notes: 'Bơi lội hoặc đạp xe'
        },
        tuesday: {
          type: 'Chạy nhẹ',
          description: 'Chạy nhịp độ nhẹ - Cường độ Zone 2',
          intensity: 'Nhẹ',
          metrics: {
            distance: '12km',
            pace: '6:00-6:30/km',
            duration: '65-70 min'
          },
          notes: 'Nhịp độ trò chuyện'
        },
        wednesday: {
          type: 'Chạy biến tốc',
          description: '15 lần chạy 400m với 90 giây nghỉ',
          intensity: 'Nặng',
          metrics: {
            distance: '15km',
            pace: '4:30-5:00/km',
            duration: '55-60 min'
          },
          notes: 'Tập trung vào kỹ thuật'
        },
        thursday: {
          type: 'Chạy nhẹ',
          description: 'Chạy hồi phục - Cường độ Zone 2',
          intensity: 'Nhẹ',
          metrics: {
            distance: '10km',
            pace: '6:00-6:30/km',
            duration: '55-60 min'
          },
          notes: 'Nhịp độ rất nhẹ'
        },
        friday: {
          type: 'Nghỉ ngơi',
          description: 'Ngày nghỉ hoàn toàn',
          intensity: 'Nghỉ ngơi',
          metrics: {
            duration: '0 min'
          },
          notes: 'Hồi phục và chuẩn bị cho buổi chạy dài'
        },
        saturday: {
          type: 'Chạy dài',
          description: 'Chạy dài với tốc độ chậm - Cường độ Zone 2',
          intensity: 'Trung bình',
          metrics: {
            distance: '32km',
            pace: '6:15-6:45/km',
            duration: '170-175 min'
          },
          notes: 'Tăng cường sức bền'
        },
        sunday: {
          type: 'Chạy nhẹ',
          description: 'Chạy hồi phục - Cường độ Zone 1-2',
          intensity: 'Nhẹ',
          metrics: {
            distance: '11km',
            pace: '6:30-7:00/km',
            duration: '60-65 min'
          },
          notes: 'Nhịp độ rất nhẹ'
        }
      },
      {
        week: 13,
        focus: 'Tăng cường sức bền',
        totalDistance: '95km',
        monday: {
          type: 'Nghỉ ngơi/Hoạt động chéo',
          description: 'Hồi phục tích cực hoặc tập luyện chéo',
          intensity: 'Hồi phục',
          metrics: {
            duration: '30-45 min'
          },
          notes: 'Bơi lội hoặc đạp xe'
        },
        tuesday: {
          type: 'Chạy nhẹ',
          description: 'Chạy nhịp độ nhẹ - Cường độ Zone 2',
          intensity: 'Nhẹ',
          metrics: {
            distance: '12km',
            pace: '6:00-6:30/km',
            duration: '65-70 min'
          },
          notes: 'Nhịp độ trò chuyện'
        },
        wednesday: {
          type: 'Chạy tempo',
          description: 'Chạy tempo 45 min ở nhịp độ bán marathon',
          intensity: 'Nặng',
          metrics: {
            distance: '18km',
            pace: '5:30-6:00/km',
            duration: '90-95 min'
          },
          notes: 'Bao gồm 10 min khởi động và giãn cơ'
        },
        thursday: {
          type: 'Chạy nhẹ',
          description: 'Chạy hồi phục - Cường độ Zone 2',
          intensity: 'Nhẹ',
          metrics: {
            distance: '10km',
            pace: '6:00-6:30/km',
            duration: '55-60 min'
          },
          notes: 'Nhịp độ rất nhẹ'
        },
        friday: {
          type: 'Nghỉ ngơi',
          description: 'Ngày nghỉ hoàn toàn',
          intensity: 'Nghỉ ngơi',
          metrics: {
            duration: '0 min'
          },
          notes: 'Hồi phục và chuẩn bị cho buổi chạy dài'
        },
        saturday: {
          type: 'Chạy dài',
          description: 'Chạy dài với tốc độ chậm - Cường độ Zone 2',
          intensity: 'Trung bình',
          metrics: {
            distance: '35km',
            pace: '6:15-6:45/km',
            duration: '180-185 min'
          },
          notes: 'Tăng cường sức bền'
        },
        sunday: {
          type: 'Chạy nhẹ',
          description: 'Chạy hồi phục - Cường độ Zone 1-2',
          intensity: 'Nhẹ',
          metrics: {
            distance: '12km',
            pace: '6:30-7:00/km',
            duration: '65-70 min'
          },
          notes: 'Nhịp độ rất nhẹ'
        }
      },
      {
        week: 14,
        focus: 'Tăng cường sức bền',
        totalDistance: '100km',
        monday: {
          type: 'Nghỉ ngơi/Hoạt động chéo',
          description: 'Hồi phục tích cực hoặc tập luyện chéo',
          intensity: 'Hồi phục',
          metrics: {
            duration: '30-45 min'
          },
          notes: 'Bơi lội hoặc đạp xe'
        },
        tuesday: {
          type: 'Chạy nhẹ',
          description: 'Chạy nhịp độ nhẹ - Cường độ Zone 2',
          intensity: 'Nhẹ',
          metrics: {
            distance: '12km',
            pace: '6:00-6:30/km',
            duration: '65-70 min'
          },
          notes: 'Nhịp độ trò chuyện'
        },
        wednesday: {
          type: 'Chạy biến tốc',
          description: '18 lần chạy 400m với 90 giây nghỉ',
          intensity: 'Nặng',
          metrics: {
            distance: '18km',
            pace: '4:30-5:00/km',
            duration: '60-65 min'
          },
          notes: 'Tập trung vào kỹ thuật'
        },
        thursday: {
          type: 'Chạy nhẹ',
          description: 'Chạy hồi phục - Cường độ Zone 2',
          intensity: 'Nhẹ',
          metrics: {
            distance: '10km',
            pace: '6:00-6:30/km',
            duration: '55-60 min'
          },
          notes: 'Nhịp độ rất nhẹ'
        },
        friday: {
          type: 'Nghỉ ngơi',
          description: 'Ngày nghỉ hoàn toàn',
          intensity: 'Nghỉ ngơi',
          metrics: {
            duration: '0 min'
          },
          notes: 'Hồi phục và chuẩn bị cho buổi chạy dài'
        },
        saturday: {
          type: 'Chạy dài',
          description: 'Chạy dài với tốc độ chậm - Cường độ Zone 2',
          intensity: 'Trung bình',
          metrics: {
            distance: '38km',
            pace: '6:15-6:45/km',
            duration: '190-195 min'
          },
          notes: 'Tăng cường sức bền'
        },
        sunday: {
          type: 'Chạy nhẹ',
          description: 'Chạy hồi phục - Cường độ Zone 1-2',
          intensity: 'Nhẹ',
          metrics: {
            distance: '12km',
            pace: '6:30-7:00/km',
            duration: '65-70 min'
          },
          notes: 'Nhịp độ rất nhẹ'
        }
      },
      {
        week: 15,
        focus: 'Giảm tải',
        totalDistance: '60km',
        monday: {
          type: 'Nghỉ ngơi/Hoạt động chéo',
          description: 'Hồi phục tích cực hoặc tập luyện chéo',
          intensity: 'Hồi phục',
          metrics: {
            duration: '30-45 min'
          },
          notes: 'Bơi lội hoặc đạp xe'
        },
        tuesday: {
          type: 'Chạy nhẹ',
          description: 'Chạy nhịp độ nhẹ - Cường độ Zone 2',
          intensity: 'Nhẹ',
          metrics: {
            distance: '8km',
            pace: '6:00-6:30/km',
            duration: '45-50 min'
          },
          notes: 'Nhịp độ trò chuyện'
        },
        wednesday: {
          type: 'Chạy tempo',
          description: 'Chạy tempo 20 min ở nhịp độ bán marathon',
          intensity: 'Nặng',
          metrics: {
            distance: '10km',
            pace: '5:30-6:00/km',
            duration: '50-55 min'
          },
          notes: 'Bao gồm 10 min khởi động và giãn cơ'
        },
        thursday: {
          type: 'Chạy nhẹ',
          description: 'Chạy hồi phục - Cường độ Zone 2',
          intensity: 'Nhẹ',
          metrics: {
            distance: '6km',
            pace: '6:00-6:30/km',
            duration: '35-40 min'
          },
          notes: 'Nhịp độ rất nhẹ'
        },
        friday: {
          type: 'Nghỉ ngơi',
          description: 'Ngày nghỉ hoàn toàn',
          intensity: 'Nghỉ ngơi',
          metrics: {
            duration: '0 min'
          },
          notes: 'Hồi phục và chuẩn bị cho buổi chạy dài'
        },
        saturday: {
          type: 'Chạy dài',
          description: 'Chạy dài với tốc độ chậm - Cường độ Zone 2',
          intensity: 'Trung bình',
          metrics: {
            distance: '20km',
            pace: '6:15-6:45/km',
            duration: '110-115 min'
          },
          notes: 'Giảm tải trước ngày đua'
        },
        sunday: {
          type: 'Chạy nhẹ',
          description: 'Chạy hồi phục - Cường độ Zone 1-2',
          intensity: 'Nhẹ',
          metrics: {
            distance: '8km',
            pace: '6:30-7:00/km',
            duration: '45-50 min'
          },
          notes: 'Nhịp độ rất nhẹ'
        }
      },
      {
        week: 16,
        focus: 'Giảm tải và chuẩn bị đua',
        totalDistance: '30km',
        monday: {
          type: 'Nghỉ ngơi/Hoạt động chéo',
          description: 'Hồi phục tích cực hoặc tập luyện chéo',
          intensity: 'Hồi phục',
          metrics: {
            duration: '20-30 min'
          },
          notes: 'Bơi lội nhẹ'
        },
        tuesday: {
          type: 'Chạy nhẹ',
          description: 'Chạy nhịp độ nhẹ - Cường độ Zone 2',
          intensity: 'Nhẹ',
          metrics: {
            distance: '6km',
            pace: '6:00-6:30/km',
            duration: '35-40 min'
          },
          notes: 'Nhịp độ trò chuyện'
        },
        wednesday: {
          type: 'Chạy nhẹ',
          description: 'Chạy nhẹ với một vài đoạn ngắn',
          intensity: 'Nhẹ',
          metrics: {
            distance: '4km',
            pace: '6:00-6:30/km',
            duration: '25-30 min'
          },
          notes: 'Bao gồm 4x100m chạy nhanh'
        },
        thursday: {
          type: 'Nghỉ ngơi',
          description: 'Ngày nghỉ hoàn toàn',
          intensity: 'Nghỉ ngơi',
          metrics: {
            duration: '0 min'
          },
          notes: 'Hồi phục hoàn toàn'
        },
        friday: {
          type: 'Chạy nhẹ',
          description: 'Chạy nhẹ 20 min',
          intensity: 'Nhẹ',
          metrics: {
            distance: '3km',
            pace: '6:30-7:00/km',
            duration: '20 min'
          },
          notes: 'Chuẩn bị cho ngày đua'
        },
        saturday: {
          type: 'Nghỉ ngơi',
          description: 'Ngày nghỉ hoàn toàn',
          intensity: 'Nghỉ ngơi',
          metrics: {
            duration: '0 min'
          },
          notes: 'Hồi phục và chuẩn bị cho ngày đua'
        },
        sunday: {
          type: 'Ngày đua',
          description: 'Full Marathon',
          intensity: 'Đua',
          metrics: {
            distance: '42.2km',
            pace: 'Nhịp độ đua',
            duration: '3:30-5:00'
          },
          notes: 'Ngày đua! Tin tưởng vào quá trình luyện tập và tận hưởng trải nghiệm'
        }
      }
    ]
  },
  {
    id: 'half-marathon-16-weeks-en',
    name: 'Half Marathon Training Plan',
    description: 'Professional 16-week training plan with structured progression',
    duration: 16,
    distance: '21.1km',
    targetTime: '1:45-2:30',
    language: 'en',
    type: 'half-marathon',
    weeks: [
      {
        week: 1,
        focus: 'Base Building',
        totalDistance: '25km',
        monday: {

          type: 'Rest/Cross-Training',

          description: 'Active recovery or cross-training',

          intensity: 'Recovery',

          metrics: {

            duration: '30-45 min'

          },

          notes: 'Swimming'

        },
        tuesday: {
          type: 'Easy Run',
          description: 'Easy pace run - Zone 2 effort',
          intensity: 'Easy',
          metrics: {
            distance: '5km',
            pace: '6:00-6:30/km',
            duration: '30-35 min'
          },
          notes: 'Conversational pace, build aerobic base'
        },
        wednesday: {
          type: 'Interval',
          description: '4x400m intervals with 90s rest',
          intensity: 'Hard',
          metrics: {
            distance: '4km',
            pace: '4:30-5:00/km',
            duration: '25-30 min'
          },
          notes: 'Focus on form, controlled breathing'
        },
        thursday: {
          type: 'Easy Run',
          description: 'Recovery run - Zone 2 effort',
          intensity: 'Easy',
          metrics: {
            distance: '5km',
            pace: '6:00-6:30/km',
            duration: '30-35 min'
          },
          notes: 'Very easy pace, active recovery'
        },
        friday: {
          type: 'Rest',
          description: 'Complete rest day',
          intensity: 'Rest',
          metrics: {
            duration: '0 min'
          },
          notes: 'Recovery and preparation for long run'
        },
        saturday: {
          type: 'Long Run',
          description: 'Long slow distance run - Zone 2 effort',
          intensity: 'Moderate',
          metrics: {
            distance: '8km',
            pace: '6:15-6:45/km',
            duration: '50-55 min'
          },
          notes: 'Build endurance, practice race nutrition'
        },
        sunday: {
          type: 'Easy Run',
          description: 'Recovery run - Zone 1-2 effort',
          intensity: 'Easy',
          metrics: {
            distance: '3km',
            pace: '6:30-7:00/km',
            duration: '20-25 min'
          },
          notes: 'Very easy pace, active recovery'
        }
      },
      {
        week: 2,
        focus: 'Endurance Building',
        totalDistance: '28km',
        monday: {

          type: 'Rest/Cross-Training',

          description: 'Active recovery or cross-training',

          intensity: 'Recovery',

          metrics: {

            duration: '30-45 min'

          },

          notes: 'Swimming'

        },
        tuesday: {

          type: 'Easy Run',

          description: 'Easy pace run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '5km',

            pace: '6:00-6:30/km',

            duration: '30-35 min'

          },

          notes: 'Conversational pace'

        },
        wednesday: {

          type: 'Interval',

          description: '4x400m intervals with 90s rest',

          intensity: 'Hard',

          metrics: {

            distance: '4km',

            pace: '4:30-5:00/km',

            duration: '25-30 min'

          },

          notes: 'Focus on form'

        },
        thursday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '5km',

            pace: '6:00-6:30/km',

            duration: '30-35 min'

          },

          notes: 'Very easy pace'

        },
        friday: {

          type: 'Rest',

          description: 'Complete rest day',

          intensity: 'Rest',

          metrics: {

            duration: '0 min'

          },

          notes: 'Recovery and preparation for long run'

        },
        saturday: {

          type: 'Long Run',

          description: 'Long slow distance run - Zone 2 effort',

          intensity: 'Moderate',

          metrics: {

            distance: '10km',

            pace: '6:15-6:45/km',

            duration: '60-65 min'

          },

          notes: 'Build endurance'

        },
        sunday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 1-2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '3km',

            pace: '6:30-7:00/km',

            duration: '20-25 min'

          },

          notes: 'Very easy pace'

        }
      },
      {
        week: 3,
        focus: 'Endurance Building',
        totalDistance: '32km',
        monday: {

          type: 'Rest/Cross-Training',

          description: 'Active recovery or cross-training',

          intensity: 'Recovery',

          metrics: {

            duration: '30-45 min'

          },

          notes: 'Swimming'

        },
        tuesday: {

          type: 'Easy Run',

          description: 'Easy pace run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '6km',

            pace: '6:00-6:30/km',

            duration: '35-40 min'

          },

          notes: 'Conversational pace'

        },
        wednesday: {

          type: 'Tempo Run',

          description: '15 min tempo at half marathon pace',

          intensity: 'Hard',

          metrics: {

            distance: '6km',

            pace: '5:30-6:00/km',

            duration: '35-40 min'

          },

          notes: 'Include 10 min warm-up and cool-down'

        },
        thursday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '5km',

            pace: '6:00-6:30/km',

            duration: '30-35 min'

          },

          notes: 'Very easy pace'

        },
        friday: {

          type: 'Rest',

          description: 'Complete rest day',

          intensity: 'Rest',

          metrics: {

            duration: '0 min'

          },

          notes: 'Recovery and preparation for long run'

        },
        saturday: {

          type: 'Long Run',

          description: 'Long slow distance run - Zone 2 effort',

          intensity: 'Moderate',

          metrics: {

            distance: '10km',

            pace: '6:15-6:45/km',

            duration: '60-65 min'

          },

          notes: 'Build endurance'

        },
        sunday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 1-2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '4km',

            pace: '6:30-7:00/km',

            duration: '25-30 min'

          },

          notes: 'Very easy pace'

        }
      },
      {
        week: 4,
        focus: 'Endurance Building',
        totalDistance: '35km',
        monday: {

          type: 'Rest/Cross-Training',

          description: 'Active recovery or cross-training',

          intensity: 'Recovery',

          metrics: {

            duration: '30-45 min'

          },

          notes: 'Swimming'

        },
        tuesday: {

          type: 'Easy Run',

          description: 'Easy pace run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '6km',

            pace: '6:00-6:30/km',

            duration: '35-40 min'

          },

          notes: 'Conversational pace'

        },
        wednesday: {

          type: 'Interval',

          description: '5x400m intervals with 90s rest',

          intensity: 'Hard',

          metrics: {

            distance: '5km',

            pace: '4:30-5:00/km (intervals)',

            duration: '30-35 min'

          },

          notes: 'Focus on form'

        },
        thursday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '5km',

            pace: '6:00-6:30/km',

            duration: '30-35 min'

          },

          notes: 'Very easy pace'

        },
        friday: {

          type: 'Rest',

          description: 'Complete rest day',

          intensity: 'Rest',

          metrics: {

            duration: '0 min'

          },

          notes: 'Recovery and preparation for long run'

        },
        saturday: {

          type: 'Long Run',

          description: 'Long slow distance run - Zone 2 effort',

          intensity: 'Moderate',

          metrics: {

            distance: '12km',

            pace: '6:15-6:45/km',

            duration: '70-75 min'

          },

          notes: 'Build endurance'

        },
        sunday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 1-2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '4km',

            pace: '6:30-7:00/km',

            duration: '25-30 min'

          },

          notes: 'Very easy pace'

        }
      },
      {
        week: 5,
        focus: 'Endurance Building',
        totalDistance: '38km',
        monday: {

          type: 'Rest/Cross-Training',

          description: 'Active recovery or cross-training',

          intensity: 'Recovery',

          metrics: {

            duration: '30-45 min'

          },

          notes: 'Swimming'

        },
        tuesday: {

          type: 'Easy Run',

          description: 'Easy pace run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '7km',

            pace: '6:00-6:30/km',

            duration: '40-45 min'

          },

          notes: 'Conversational pace'

        },
        wednesday: {

          type: 'Tempo Run',

          description: '20 min tempo at half marathon pace',

          intensity: 'Hard',

          metrics: {

            distance: '7km',

            pace: '5:30-6:00/km',

            duration: '40-45 min'

          },

          notes: 'Include 10 min warm-up and cool-down'

        },
        thursday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '6km',

            pace: '6:00-6:30/km',

            duration: '35-40 min'

          },

          notes: 'Very easy pace'

        },
        friday: {

          type: 'Rest',

          description: 'Complete rest day',

          intensity: 'Rest',

          metrics: {

            duration: '0 min'

          },

          notes: 'Recovery and preparation for long run'

        },
        saturday: {

          type: 'Long Run',

          description: 'Long slow distance run - Zone 2 effort',

          intensity: 'Moderate',

          metrics: {

            distance: '13km',

            pace: '6:15-6:45/km',

            duration: '75-80 min'

          },

          notes: 'Build endurance'

        },
        sunday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 1-2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '5km',

            pace: '6:30-7:00/km',

            duration: '30-35 min'

          },

          notes: 'Very easy pace'

        }
      },
      {
        week: 6,
        focus: 'Endurance Building',
        totalDistance: '42km',
        monday: {

          type: 'Rest/Cross-Training',

          description: 'Active recovery or cross-training',

          intensity: 'Recovery',

          metrics: {

            duration: '30-45 min'

          },

          notes: 'Swimming'

        },
        tuesday: {

          type: 'Easy Run',

          description: 'Easy pace run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '7km',

            pace: '6:00-6:30/km',

            duration: '40-45 min'

          },

          notes: 'Conversational pace'

        },
        wednesday: {

          type: 'Interval',

          description: '6x400m intervals with 90s rest',

          intensity: 'Hard',

          metrics: {

            distance: '6km',

            pace: '4:30-5:00/km',

            duration: '35-40 min'

          },

          notes: 'Focus on form'

        },
        thursday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '6km',

            pace: '6:00-6:30/km',

            duration: '35-40 min'

          },

          notes: 'Very easy pace'

        },
        friday: {

          type: 'Rest',

          description: 'Complete rest day',

          intensity: 'Rest',

          metrics: {

            duration: '0 min'

          },

          notes: 'Recovery and preparation for long run'

        },
        saturday: {

          type: 'Long Run',

          description: 'Long slow distance run - Zone 2 effort',

          intensity: 'Moderate',

          metrics: {

            distance: '15km',

            pace: '6:15-6:45/km',

            duration: '85-90 min'

          },

          notes: 'Build endurance'

        },
        sunday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 1-2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '5km',

            pace: '6:30-7:00/km',

            duration: '30-35 min'

          },

          notes: 'Very easy pace'

        }
      },
      {
        week: 7,
        focus: 'Endurance Building',
        totalDistance: '45km',
        monday: {

          type: 'Rest/Cross-Training',

          description: 'Active recovery or cross-training',

          intensity: 'Recovery',

          metrics: {

            duration: '30-45 min'

          },

          notes: 'Swimming'

        },
        tuesday: {

          type: 'Easy Run',

          description: 'Easy pace run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '8km',

            pace: '6:00-6:30/km',

            duration: '45-50 min'

          },

          notes: 'Conversational pace'

        },
        wednesday: {

          type: 'Tempo Run',

          description: '25 min tempo at half marathon pace',

          intensity: 'Hard',

          metrics: {

            distance: '8km',

            pace: '5:30-6:00/km',

            duration: '45-50 min'

          },

          notes: 'Include 10 min warm-up and cool-down'

        },
        thursday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '7km',

            pace: '6:00-6:30/km',

            duration: '40-45 min'

          },

          notes: 'Very easy pace'

        },
        friday: {

          type: 'Rest',

          description: 'Complete rest day',

          intensity: 'Rest',

          metrics: {

            duration: '0 min'

          },

          notes: 'Recovery and preparation for long run'

        },
        saturday: {

          type: 'Long Run',

          description: 'Long slow distance run - Zone 2 effort',

          intensity: 'Moderate',

          metrics: {

            distance: '16km',

            pace: '6:15-6:45/km',

            duration: '90-95 min'

          },

          notes: 'Build endurance'

        },
        sunday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 1-2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '6km',

            pace: '6:30-7:00/km',

            duration: '35-40 min'

          },

          notes: 'Very easy pace'

        }
      },
      {
        week: 8,
        focus: 'Endurance Building',
        totalDistance: '48km',
        monday: {

          type: 'Rest/Cross-Training',

          description: 'Active recovery or cross-training',

          intensity: 'Recovery',

          metrics: {

            duration: '30-45 min'

          },

          notes: 'Swimming'

        },
        tuesday: {

          type: 'Easy Run',

          description: 'Easy pace run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '8km',

            pace: '6:00-6:30/km',

            duration: '45-50 min'

          },

          notes: 'Conversational pace'

        },
        wednesday: {

          type: 'Interval',

          description: '8x400m intervals with 90s rest',

          intensity: 'Hard',

          metrics: {

            distance: '7km',

            pace: '4:30-5:00/km',

            duration: '40-45 min'

          },

          notes: 'Focus on form'

        },
        thursday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '7km',

            pace: '6:00-6:30/km',

            duration: '40-45 min'

          },

          notes: 'Very easy pace'

        },
        friday: {

          type: 'Rest',

          description: 'Complete rest day',

          intensity: 'Rest',

          metrics: {

            duration: '0 min'

          },

          notes: 'Recovery and preparation for long run'

        },
        saturday: {

          type: 'Long Run',

          description: 'Long slow distance run - Zone 2 effort',

          intensity: 'Moderate',

          metrics: {

            distance: '17km',

            pace: '6:15-6:45/km',

            duration: '95-100 min'

          },

          notes: 'Build endurance'

        },
        sunday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 1-2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '6km',

            pace: '6:30-7:00/km',

            duration: '35-40 min'

          },

          notes: 'Very easy pace'

        }
      },
      {
        week: 9,
        focus: 'Endurance Building',
        totalDistance: '50km',
        monday: {

          type: 'Rest/Cross-Training',

          description: 'Active recovery or cross-training',

          intensity: 'Recovery',

          metrics: {

            duration: '30-45 min'

          },

          notes: 'Swimming'

        },
        tuesday: {

          type: 'Easy Run',

          description: 'Easy pace run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '9km',

            pace: '6:00-6:30/km',

            duration: '50-55 min'

          },

          notes: 'Conversational pace'

        },
        wednesday: {

          type: 'Tempo Run',

          description: '30 min tempo at half marathon pace',

          intensity: 'Hard',

          metrics: {

            distance: '9km',

            pace: '5:30-6:00/km',

            duration: '50-55 min'

          },

          notes: 'Include 10 min warm-up and cool-down'

        },
        thursday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '8km',

            pace: '6:00-6:30/km',

            duration: '45-50 min'

          },

          notes: 'Very easy pace'

        },
        friday: {

          type: 'Rest',

          description: 'Complete rest day',

          intensity: 'Rest',

          metrics: {

            duration: '0 min'

          },

          notes: 'Recovery and preparation for long run'

        },
        saturday: {

          type: 'Long Run',

          description: 'Long slow distance run - Zone 2 effort',

          intensity: 'Moderate',

          metrics: {

            distance: '18km',

            pace: '6:15-6:45/km',

            duration: '100-105 min'

          },

          notes: 'Build endurance'

        },
        sunday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 1-2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '6km',

            pace: '6:30-7:00/km',

            duration: '35-40 min'

          },

          notes: 'Very easy pace'

        }
      },
      {
        week: 10,
        focus: 'Endurance Building',
        totalDistance: '52km',
        monday: {

          type: 'Rest/Cross-Training',

          description: 'Active recovery or cross-training',

          intensity: 'Recovery',

          metrics: {

            duration: '30-45 min'

          },

          notes: 'Swimming'

        },
        tuesday: {

          type: 'Easy Run',

          description: 'Easy pace run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '9km',

            pace: '6:00-6:30/km',

            duration: '50-55 min'

          },

          notes: 'Conversational pace'

        },
        wednesday: {

          type: 'Interval',

          description: '10x400m intervals with 90s rest',

          intensity: 'Hard',

          metrics: {

            distance: '8km',

            pace: '4:30-5:00/km',

            duration: '45-50 min'

          },

          notes: 'Focus on form'

        },
        thursday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '8km',

            pace: '6:00-6:30/km',

            duration: '45-50 min'

          },

          notes: 'Very easy pace'

        },
        friday: {

          type: 'Rest',

          description: 'Complete rest day',

          intensity: 'Rest',

          metrics: {

            duration: '0 min'

          },

          notes: 'Recovery and preparation for long run'

        },
        saturday: {

          type: 'Long Run',

          description: 'Long slow distance run - Zone 2 effort',

          intensity: 'Moderate',

          metrics: {

            distance: '19km',

            pace: '6:15-6:45/km',

            duration: '105-110 min'

          },

          notes: 'Build endurance'

        },
        sunday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 1-2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '7km',

            pace: '6:30-7:00/km',

            duration: '40-45 min'

          },

          notes: 'Very easy pace'

        }
      },
      {
        week: 11,
        focus: 'Endurance Building',
        totalDistance: '55km',
        monday: {

          type: 'Rest/Cross-Training',

          description: 'Active recovery or cross-training',

          intensity: 'Recovery',

          metrics: {

            duration: '30-45 min'

          },

          notes: 'Swimming'

        },
        tuesday: {

          type: 'Easy Run',

          description: 'Easy pace run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '10km',

            pace: '6:00-6:30/km',

            duration: '55-60 min'

          },

          notes: 'Conversational pace'

        },
        wednesday: {

          type: 'Tempo Run',

          description: '35 min tempo at half marathon pace',

          intensity: 'Hard',

          metrics: {

            distance: '10km',

            pace: '5:30-6:00/km',

            duration: '55-60 min'

          },

          notes: 'Include 10 min warm-up and cool-down'

        },
        thursday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '9km',

            pace: '6:00-6:30/km',

            duration: '50-55 min'

          },

          notes: 'Very easy pace'

        },
        friday: {

          type: 'Rest',

          description: 'Complete rest day',

          intensity: 'Rest',

          metrics: {

            duration: '0 min'

          },

          notes: 'Recovery and preparation for long run'

        },
        saturday: {

          type: 'Long Run',

          description: 'Long slow distance run - Zone 2 effort',

          intensity: 'Moderate',

          metrics: {

            distance: '20km',

            pace: '6:15-6:45/km',

            duration: '110-115 min'

          },

          notes: 'Build endurance'

        },
        sunday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 1-2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '7km',

            pace: '6:30-7:00/km',

            duration: '40-45 min'

          },

          notes: 'Very easy pace'

        }
      },
      {
        week: 12,
        focus: 'Endurance Building',
        totalDistance: '58km',
        monday: {

          type: 'Rest/Cross-Training',

          description: 'Active recovery or cross-training',

          intensity: 'Recovery',

          metrics: {

            duration: '30-45 min'

          },

          notes: 'Swimming'

        },
        tuesday: {

          type: 'Easy Run',

          description: 'Easy pace run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '10km',

            pace: '6:00-6:30/km',

            duration: '55-60 min'

          },

          notes: 'Conversational pace'

        },
        wednesday: {

          type: 'Interval',

          description: '12x400m intervals with 90s rest',

          intensity: 'Hard',

          metrics: {

            distance: '9km',

            pace: '4:30-5:00/km',

            duration: '50-55 min'

          },

          notes: 'Focus on form'

        },
        thursday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '9km',

            pace: '6:00-6:30/km',

            duration: '50-55 min'

          },

          notes: 'Very easy pace'

        },
        friday: {

          type: 'Rest',

          description: 'Complete rest day',

          intensity: 'Rest',

          metrics: {

            duration: '0 min'

          },

          notes: 'Recovery and preparation for long run'

        },
        saturday: {

          type: 'Long Run',

          description: 'Long slow distance run - Zone 2 effort',

          intensity: 'Moderate',

          metrics: {

            distance: '21km',

            pace: '6:15-6:45/km',

            duration: '115-120 min'

          },

          notes: 'Build endurance'

        },
        sunday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 1-2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '8km',

            pace: '6:30-7:00/km',

            duration: '45-50 min'

          },

          notes: 'Very easy pace'

        }
      },
      {
        week: 13,
        focus: 'Endurance Building',
        totalDistance: '60km',
        monday: {

          type: 'Rest/Cross-Training',

          description: 'Active recovery or cross-training',

          intensity: 'Recovery',

          metrics: {

            duration: '30-45 min'

          },

          notes: 'Swimming'

        },
        tuesday: {

          type: 'Easy Run',

          description: 'Easy pace run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '11km',

            pace: '6:00-6:30/km',

            duration: '60-65 min'

          },

          notes: 'Conversational pace'

        },
        wednesday: {

          type: 'Tempo Run',

          description: '40 min tempo at half marathon pace',

          intensity: 'Hard',

          metrics: {

            distance: '11km',

            pace: '5:30-6:00/km',

            duration: '60-65 min'

          },

          notes: 'Include 10 min warm-up and cool-down'

        },
        thursday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '10km',

            pace: '6:00-6:30/km',

            duration: '55-60 min'

          },

          notes: 'Very easy pace'

        },
        friday: {

          type: 'Rest',

          description: 'Complete rest day',

          intensity: 'Rest',

          metrics: {

            duration: '0 min'

          },

          notes: 'Recovery and preparation for long run'

        },
        saturday: {

          type: 'Long Run',

          description: 'Long slow distance run - Zone 2 effort',

          intensity: 'Moderate',

          metrics: {

            distance: '22km',

            pace: '6:15-6:45/km',

            duration: '120-125 min'

          },

          notes: 'Build endurance'

        },
        sunday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 1-2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '8km',

            pace: '6:30-7:00/km',

            duration: '45-50 min'

          },

          notes: 'Very easy pace'

        }
      },
      {
        week: 14,
        focus: 'Endurance Building',
        totalDistance: '62km',
        monday: {

          type: 'Rest/Cross-Training',

          description: 'Active recovery or cross-training',

          intensity: 'Recovery',

          metrics: {

            duration: '30-45 min'

          },

          notes: 'Swimming'

        },
        tuesday: {

          type: 'Easy Run',

          description: 'Easy pace run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '11km',

            pace: '6:00-6:30/km',

            duration: '60-65 min'

          },

          notes: 'Conversational pace'

        },
        wednesday: {

          type: 'Interval',

          description: '14x400m intervals with 90s rest',

          intensity: 'Hard',

          metrics: {

            distance: '10km',

            pace: '4:30-5:00/km',

            duration: '55-60 min'

          },

          notes: 'Focus on form'

        },
        thursday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '10km',

            pace: '6:00-6:30/km',

            duration: '55-60 min'

          },

          notes: 'Very easy pace'

        },
        friday: {

          type: 'Rest',

          description: 'Complete rest day',

          intensity: 'Rest',

          metrics: {

            duration: '0 min'

          },

          notes: 'Recovery and preparation for long run'

        },
        saturday: {

          type: 'Long Run',

          description: 'Long slow distance run - Zone 2 effort',

          intensity: 'Moderate',

          metrics: {

            distance: '23km',

            pace: '6:15-6:45/km',

            duration: '125-130 min'

          },

          notes: 'Build endurance'

        },
        sunday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 1-2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '8km',

            pace: '6:30-7:00/km',

            duration: '45-50 min'

          },

          notes: 'Very easy pace'

        }
      },
      {
        week: 15,
        focus: 'Tapering',
        totalDistance: '45km',
        monday: {

          type: 'Rest/Cross-Training',

          description: 'Active recovery or cross-training',

          intensity: 'Recovery',

          metrics: {

            duration: '30-45 min'

          },

          notes: 'Swimming'

        },
        tuesday: {

          type: 'Easy Run',

          description: 'Easy pace run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '8km',

            pace: '6:00-6:30/km',

            duration: '45-50 min'

          },

          notes: 'Conversational pace'

        },
        wednesday: {

          type: 'Tempo Run',

          description: '15 min tempo at half marathon pace',

          intensity: 'Moderate',

          metrics: {

            distance: '7km',

            pace: '5:30-6:00/km',

            duration: '40-45 min'

          },

          notes: 'Include 10 min warm-up and cool-down'

        },
        thursday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '8km',

            pace: '6:00-6:30/km',

            duration: '45-50 min'

          },

          notes: 'Very easy pace'

        },
        friday: {

          type: 'Rest',

          description: 'Complete rest day',

          intensity: 'Rest',

          metrics: {

            duration: '0 min'

          },

          notes: 'Recovery and preparation for long run'

        },
        saturday: {

          type: 'Long Run',

          description: 'Long slow distance run - Zone 2 effort',

          intensity: 'Moderate',

          metrics: {

            distance: '12km',

            pace: '6:15-6:45/km',

            duration: '65-70 min'

          },

          notes: 'Final long run'

        },
        sunday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 1-2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '6km',

            pace: '6:30-7:00/km',

            duration: '35-40 min'

          },

          notes: 'Very easy pace'

        }
      },
      {
        week: 16,
        focus: 'Race Week',
        totalDistance: '25km',
        monday: {

          type: 'Easy Run',

          description: 'Very easy pace run',

          intensity: 'Easy',

          metrics: {

            distance: '4km',

            pace: '6:30-7:00/km',

            duration: '25-30 min'

          },

          notes: 'Very easy pace'

        },
        tuesday: {

          type: 'Easy Run',

          description: 'Easy pace run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '5km',

            pace: '6:00-6:30/km',

            duration: '30-35 min'

          },

          notes: 'Conversational pace'

        },
        wednesday: {

          type: 'Easy Run',

          description: 'Very easy pace run',

          intensity: 'Easy',

          metrics: {

            distance: '3km',

            pace: '6:30-7:00/km',

            duration: '20-25 min'

          },

          notes: 'Very easy pace'

        },
        thursday: {

          type: 'Rest',

          description: 'Complete rest day',

          intensity: 'Rest',

          metrics: {

            duration: '0 min'

          },

          notes: 'Recovery and preparation for race'

        },
        friday: {

          type: 'Easy Run',

          description: 'Very easy pace run',

          intensity: 'Easy',

          metrics: {

            distance: '3km',

            pace: '6:30-7:00/km',

            duration: '20-25 min'

          },

          notes: 'Very easy pace'

        },
        saturday: {

          type: 'Rest',

          description: 'Complete rest day',

          intensity: 'Rest',

          metrics: {

            duration: '0 min'

          },

          notes: 'Rest and prepare for race day'

        },
        sunday: {

          type: 'Race Day',

          description: 'Half Marathon Race',

          intensity: 'Race',

          metrics: {

            distance: '21.1km',

            pace: 'Race pace',

            duration: '1:45-2:30'

          },

          notes: 'Race day! Trust your training and enjoy the experience'

        }
      }
    ]
  },
  {
    id: 'full-marathon-16-weeks-en',
    name: 'Full Marathon Training Plan',
    description: 'Comprehensive 16-week marathon preparation',
    duration: 16,
    distance: '42.2km',
    targetTime: '3:30-5:00',
    language: 'en',
    type: 'full-marathon',
    weeks: [
      {
        week: 1,
        focus: 'Base Building',
        totalDistance: '35km',
        monday: {

          type: 'Rest/Cross-Training',

          description: 'Active recovery or cross-training',

          intensity: 'Recovery',

          metrics: {

            duration: '30-45 min'

          },

          notes: 'Swimming'

        },
        tuesday: {

          type: 'Easy Run',

          description: 'Easy pace run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '6km',

            pace: '6:00-6:30/km',

            duration: '35-40 min'

          },

          notes: 'Conversational pace'

        },
        wednesday: {

          type: 'Interval',

          description: '5x400m intervals with 90s rest',

          intensity: 'Hard',

          metrics: {

            distance: '5km',

            pace: '4:30-5:00/km',

            duration: '30-35 min'

          },

          notes: 'Focus on form'

        },
        thursday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '6km',

            pace: '6:00-6:30/km',

            duration: '35-40 min'

          },

          notes: 'Very easy pace'

        },
        friday: {

          type: 'Rest',

          description: 'Complete rest day',

          intensity: 'Rest',

          metrics: {

            duration: '0 min'

          },

          notes: 'Recovery and preparation for long run'

        },
        saturday: {

          type: 'Long Run',

          description: 'Long slow distance run - Zone 2 effort',

          intensity: 'Moderate',

          metrics: {

            distance: '10km',

            pace: '6:15-6:45/km',

            duration: '60-65 min'

          },

          notes: 'Build endurance'

        },
        sunday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 1-2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '4km',

            pace: '6:30-7:00/km',

            duration: '25-30 min'

          },

          notes: 'Very easy pace'

        }
      },
      {
        week: 2,
        focus: 'Endurance Building',
        totalDistance: '40km',
        monday: {

          type: 'Rest/Cross-Training',

          description: 'Active recovery or cross-training',

          intensity: 'Recovery',

          metrics: {

            duration: '30-45 min'

          },

          notes: 'Swimming'

        },
        tuesday: {

          type: 'Easy Run',

          description: 'Easy pace run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '6km',

            pace: '6:00-6:30/km',

            duration: '35-40 min'

          },

          notes: 'Conversational pace'

        },
        wednesday: {

          type: 'Interval',

          description: '5x400m intervals with 90s rest',

          intensity: 'Hard',

          metrics: {

            distance: '5km',

            pace: '4:30-5:00/km',

            duration: '30-35 min'

          },

          notes: 'Focus on form'

        },
        thursday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '6km',

            pace: '6:00-6:30/km',

            duration: '35-40 min'

          },

          notes: 'Very easy pace'

        },
        friday: {

          type: 'Rest',

          description: 'Complete rest day',

          intensity: 'Rest',

          metrics: {

            duration: '0 min'

          },

          notes: 'Recovery and preparation for long run'

        },
        saturday: {

          type: 'Long Run',

          description: 'Long slow distance run - Zone 2 effort',

          intensity: 'Moderate',

          metrics: {

            distance: '12km',

            pace: '6:15-6:45/km',

            duration: '70-75 min'

          },

          notes: 'Build endurance'

        },
        sunday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 1-2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '4km',

            pace: '6:30-7:00/km',

            duration: '25-30 min'

          },

          notes: 'Very easy pace'

        }
      },
      {
        week: 3,
        focus: 'Endurance Building',
        totalDistance: '45km',
        monday: {

          type: 'Rest/Cross-Training',

          description: 'Active recovery or cross-training',

          intensity: 'Recovery',

          metrics: {

            duration: '30-45 min'

          },

          notes: 'Swimming'

        },
        tuesday: {

          type: 'Easy Run',

          description: 'Easy pace run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '8km',

            pace: '6:00-6:30/km',

            duration: '45-50 min'

          },

          notes: 'Conversational pace'

        },
        wednesday: {

          type: 'Tempo Run',

          description: '20 min tempo at half marathon pace',

          intensity: 'Hard',

          metrics: {

            distance: '8km',

            pace: '5:30-6:00/km',

            duration: '40-45 min'

          },

          notes: 'Include 10 min warm-up and cool-down'

        },
        thursday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '6km',

            pace: '6:00-6:30/km',

            duration: '35-40 min'

          },

          notes: 'Very easy pace'

        },
        friday: {

          type: 'Rest',

          description: 'Complete rest day',

          intensity: 'Rest',

          metrics: {

            duration: '0 min'

          },

          notes: 'Recovery and preparation for long run'

        },
        saturday: {

          type: 'Long Run',

          description: 'Long slow distance run - Zone 2 effort',

          intensity: 'Moderate',

          metrics: {

            distance: '14km',

            pace: '6:15-6:45/km',

            duration: '80-85 min'

          },

          notes: 'Build endurance'

        },
        sunday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 1-2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '5km',

            pace: '6:30-7:00/km',

            duration: '30-35 min'

          },

          notes: 'Very easy pace'

        }
      },
      {
        week: 4,
        focus: 'Endurance Building',
        totalDistance: '50km',
        monday: {

          type: 'Rest/Cross-Training',

          description: 'Active recovery or cross-training',

          intensity: 'Recovery',

          metrics: {

            duration: '30-45 min'

          },

          notes: 'Swimming'

        },
        tuesday: {

          type: 'Easy Run',

          description: 'Easy pace run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '8km',

            pace: '6:00-6:30/km',

            duration: '45-50 min'

          },

          notes: 'Conversational pace'

        },
        wednesday: {

          type: 'Interval',

          description: '6x800m intervals with 2 min rest',

          intensity: 'Hard',

          metrics: {

            distance: '8km',

            pace: '4:30-5:00/km',

            duration: '40-45 min'

          },

          notes: 'Focus on form'

        },
        thursday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '6km',

            pace: '6:00-6:30/km',

            duration: '35-40 min'

          },

          notes: 'Very easy pace'

        },
        friday: {

          type: 'Rest',

          description: 'Complete rest day',

          intensity: 'Rest',

          metrics: {

            duration: '0 min'

          },

          notes: 'Recovery and preparation for long run'

        },
        saturday: {

          type: 'Long Run',

          description: 'Long slow distance run - Zone 2 effort',

          intensity: 'Moderate',

          metrics: {

            distance: '16km',

            pace: '6:15-6:45/km',

            duration: '90-95 min'

          },

          notes: 'Build endurance'

        },
        sunday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 1-2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '5km',

            pace: '6:30-7:00/km',

            duration: '30-35 min'

          },

          notes: 'Very easy pace'

        }
      },
      {
        week: 5,
        focus: 'Endurance Building',
        totalDistance: '55km',
        monday: {

          type: 'Rest/Cross-Training',

          description: 'Active recovery or cross-training',

          intensity: 'Recovery',

          metrics: {

            duration: '30-45 min'

          },

          notes: 'Swimming'

        },
        tuesday: {

          type: 'Easy Run',

          description: 'Easy pace run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '10km',

            pace: '6:00-6:30/km',

            duration: '55-60 min'

          },

          notes: 'Conversational pace'

        },
        wednesday: {

          type: 'Tempo Run',

          description: '25 min tempo at half marathon pace',

          intensity: 'Hard',

          metrics: {

            distance: '10km',

            pace: '5:30-6:00/km',

            duration: '50-55 min'

          },

          notes: 'Include 10 min warm-up and cool-down'

        },
        thursday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '8km',

            pace: '6:00-6:30/km',

            duration: '45-50 min'

          },

          notes: 'Very easy pace'

        },
        friday: {

          type: 'Rest',

          description: 'Complete rest day',

          intensity: 'Rest',

          metrics: {

            duration: '0 min'

          },

          notes: 'Recovery and preparation for long run'

        },
        saturday: {

          type: 'Long Run',

          description: 'Long slow distance run - Zone 2 effort',

          intensity: 'Moderate',

          metrics: {

            distance: '18km',

            pace: '6:15-6:45/km',

            duration: '100-105 min'

          },

          notes: 'Build endurance'

        },
        sunday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 1-2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '6km',

            pace: '6:30-7:00/km',

            duration: '35-40 min'

          },

          notes: 'Very easy pace'

        }
      },
      {
        week: 6,
        focus: 'Endurance Building',
        totalDistance: '60km',
        monday: {

          type: 'Rest/Cross-Training',

          description: 'Active recovery or cross-training',

          intensity: 'Recovery',

          metrics: {

            duration: '30-45 min'

          },

          notes: 'Swimming'

        },
        tuesday: {

          type: 'Easy Run',

          description: 'Easy pace run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '10km',

            pace: '6:00-6:30/km',

            duration: '55-60 min'

          },

          notes: 'Conversational pace'

        },
        wednesday: {

          type: 'Interval',

          description: '8x800m intervals with 2 min rest',

          intensity: 'Hard',

          metrics: {

            distance: '10km',

            pace: '4:30-5:00/km',

            duration: '50-55 min'

          },

          notes: 'Focus on form'

        },
        thursday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '8km',

            pace: '6:00-6:30/km',

            duration: '45-50 min'

          },

          notes: 'Very easy pace'

        },
        friday: {

          type: 'Rest',

          description: 'Complete rest day',

          intensity: 'Rest',

          metrics: {

            duration: '0 min'

          },

          notes: 'Recovery and preparation for long run'

        },
        saturday: {

          type: 'Long Run',

          description: 'Long slow distance run - Zone 2 effort',

          intensity: 'Moderate',

          metrics: {

            distance: '20km',

            pace: '6:15-6:45/km',

            duration: '110-115 min'

          },

          notes: 'Build endurance'

        },
        sunday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 1-2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '6km',

            pace: '6:30-7:00/km',

            duration: '35-40 min'

          },

          notes: 'Very easy pace'

        }
      },
      {
        week: 7,
        focus: 'Endurance Building',
        totalDistance: '65km',
        monday: {

          type: 'Rest/Cross-Training',

          description: 'Active recovery or cross-training',

          intensity: 'Recovery',

          metrics: {

            duration: '30-45 min'

          },

          notes: 'Swimming'

        },
        tuesday: {

          type: 'Easy Run',

          description: 'Easy pace run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '12km',

            pace: '6:00-6:30/km',

            duration: '65-70 min'

          },

          notes: 'Conversational pace'

        },
        wednesday: {

          type: 'Tempo Run',

          description: '30 min tempo at half marathon pace',

          intensity: 'Hard',

          metrics: {

            distance: '12km',

            pace: '5:30-6:00/km',

            duration: '60-65 min'

          },

          notes: 'Include 10 min warm-up and cool-down'

        },
        thursday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '10km',

            pace: '6:00-6:30/km',

            duration: '55-60 min'

          },

          notes: 'Very easy pace'

        },
        friday: {

          type: 'Rest',

          description: 'Complete rest day',

          intensity: 'Rest',

          metrics: {

            duration: '0 min'

          },

          notes: 'Recovery and preparation for long run'

        },
        saturday: {

          type: 'Long Run',

          description: 'Long slow distance run - Zone 2 effort',

          intensity: 'Moderate',

          metrics: {

            distance: '22km',

            pace: '6:15-6:45/km',

            duration: '120-125 min'

          },

          notes: 'Build endurance'

        },
        sunday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 1-2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '7km',

            pace: '6:30-7:00/km',

            duration: '40-45 min'

          },

          notes: 'Very easy pace'

        }
      },
      {
        week: 8,
        focus: 'Endurance Building',
        totalDistance: '70km',
        monday: {

          type: 'Rest/Cross-Training',

          description: 'Active recovery or cross-training',

          intensity: 'Recovery',

          metrics: {

            duration: '30-45 min'

          },

          notes: 'Swimming'

        },
        tuesday: {

          type: 'Easy Run',

          description: 'Easy pace run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '12km',

            pace: '6:00-6:30/km',

            duration: '65-70 min'

          },

          notes: 'Conversational pace'

        },
        wednesday: {

          type: 'Interval',

          description: '10x800m intervals with 2 min rest',

          intensity: 'Hard',

          metrics: {

            distance: '12km',

            pace: '4:30-5:00/km',

            duration: '60-65 min'

          },

          notes: 'Focus on form'

        },
        thursday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '10km',

            pace: '6:00-6:30/km',

            duration: '55-60 min'

          },

          notes: 'Very easy pace'

        },
        friday: {

          type: 'Rest',

          description: 'Complete rest day',

          intensity: 'Rest',

          metrics: {

            duration: '0 min'

          },

          notes: 'Recovery and preparation for long run'

        },
        saturday: {

          type: 'Long Run',

          description: 'Long slow distance run - Zone 2 effort',

          intensity: 'Moderate',

          metrics: {

            distance: '24km',

            pace: '6:15-6:45/km',

            duration: '130-135 min'

          },

          notes: 'Build endurance'

        },
        sunday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 1-2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '7km',

            pace: '6:30-7:00/km',

            duration: '40-45 min'

          },

          notes: 'Very easy pace'
        }
      },
      {
        week: 9,
        focus: 'Endurance Building',
        totalDistance: '75km',
        monday: {

          type: 'Rest/Cross-Training',

          description: 'Active recovery or cross-training',

          intensity: 'Recovery',

          metrics: {

            duration: '30-45 min'

          },

          notes: 'Swimming'

        },
        tuesday: {

          type: 'Easy Run',

          description: 'Easy pace run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '14km',

            pace: '6:00-6:30/km',

            duration: '75-80 min'

          },

          notes: 'Conversational pace'

        },
        wednesday: {

          type: 'Tempo Run',

          description: '35 min tempo at half marathon pace',

          intensity: 'Hard',

          metrics: {

            distance: '14km',

            pace: '5:30-6:00/km',

            duration: '70-75 min'

          },

          notes: 'Include 10 min warm-up and cool-down'

        },
        thursday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '12km',

            pace: '6:00-6:30/km',

            duration: '65-70 min'

          },

          notes: 'Very easy pace'

        },
        friday: {

          type: 'Rest',

          description: 'Complete rest day',

          intensity: 'Rest',

          metrics: {

            duration: '0 min'

          },

          notes: 'Recovery and preparation for long run'

        },
        saturday: {

          type: 'Long Run',

          description: 'Long slow distance run - Zone 2 effort',

          intensity: 'Moderate',

          metrics: {

            distance: '26km',

            pace: '6:15-6:45/km',

            duration: '140-145 min'

          },

          notes: 'Build endurance'

        },
        sunday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 1-2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '8km',

            pace: '6:30-7:00/km',

            duration: '45-50 min'

          },

          notes: 'Very easy pace'

        }
      },
      {
        week: 10,
        focus: 'Endurance Building',
        totalDistance: '80km',
        monday: {

          type: 'Rest/Cross-Training',

          description: 'Active recovery or cross-training',

          intensity: 'Recovery',

          metrics: {

            duration: '30-45 min'

          },

          notes: 'Swimming'

        },
        tuesday: {

          type: 'Easy Run',

          description: 'Easy pace run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '14km',

            pace: '6:00-6:30/km',

            duration: '75-80 min'

          },

          notes: 'Conversational pace'

        },
        wednesday: {

          type: 'Interval',

          description: '12x800m intervals with 2 min rest',

          intensity: 'Hard',

          metrics: {

            distance: '14km',

            pace: '4:30-5:00/km',

            duration: '70-75 min'

          },

          notes: 'Focus on form'

        },
        thursday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '12km',

            pace: '6:00-6:30/km',

            duration: '65-70 min'

          },

          notes: 'Very easy pace'

        },
        friday: {

          type: 'Rest',

          description: 'Complete rest day',

          intensity: 'Rest',

          metrics: {

            duration: '0 min'

          },

          notes: 'Recovery and preparation for long run'

        },
        saturday: {

          type: 'Long Run',

          description: 'Long slow distance run - Zone 2 effort',

          intensity: 'Moderate',

          metrics: {

            distance: '28km',

            pace: '6:15-6:45/km',

            duration: '150-155 min'

          },

          notes: 'Build endurance'

        },
        sunday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 1-2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '8km',

            pace: '6:30-7:00/km',

            duration: '45-50 min'

          },

          notes: 'Very easy pace'

        }
      },
      {
        week: 11,
        focus: 'Endurance Building',
        totalDistance: '85km',
        monday: {

          type: 'Rest/Cross-Training',

          description: 'Active recovery or cross-training',

          intensity: 'Recovery',

          metrics: {

            duration: '30-45 min'

          },

          notes: 'Swimming'

        },
        tuesday: {

          type: 'Easy Run',

          description: 'Easy pace run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '16km',

            pace: '6:00-6:30/km',

            duration: '85-90 min'

          },

          notes: 'Conversational pace'

        },
        wednesday: {

          type: 'Tempo Run',

          description: '40 min tempo at half marathon pace',

          intensity: 'Hard',

          metrics: {

            distance: '16km',

            pace: '5:30-6:00/km',

            duration: '80-85 min'

          },

          notes: 'Include 10 min warm-up and cool-down'

        },
        thursday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '14km',

            pace: '6:00-6:30/km',

            duration: '75-80 min'

          },

          notes: 'Very easy pace'

        },
        friday: {

          type: 'Rest',

          description: 'Complete rest day',

          intensity: 'Rest',

          metrics: {

            duration: '0 min'

          },

          notes: 'Recovery and preparation for long run'

        },
        saturday: {

          type: 'Long Run',

          description: 'Long slow distance run - Zone 2 effort',

          intensity: 'Moderate',

          metrics: {

            distance: '30km',

            pace: '6:15-6:45/km',

            duration: '160-165 min'

          },

          notes: 'Build endurance'

        },
        sunday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 1-2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '9km',

            pace: '6:30-7:00/km',

            duration: '50-55 min'

          },

          notes: 'Very easy pace'

        }
      },
      {
        week: 12,
        focus: 'Endurance Building',
        totalDistance: '90km',
        monday: {

          type: 'Rest/Cross-Training',

          description: 'Active recovery or cross-training',

          intensity: 'Recovery',

          metrics: {

            duration: '30-45 min'

          },

          notes: 'Swimming'

        },
        tuesday: {

          type: 'Easy Run',

          description: 'Easy pace run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '16km',

            pace: '6:00-6:30/km',

            duration: '85-90 min'

          },

          notes: 'Conversational pace'

        },
        wednesday: {

          type: 'Interval',

          description: '14x800m intervals with 2 min rest',

          intensity: 'Hard',

          metrics: {

            distance: '16km',

            pace: '4:30-5:00/km (intervals)',

            duration: '80-85 min'

          },

          notes: 'Focus on form'

        },
        thursday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '14km',

            pace: '6:00-6:30/km',

            duration: '75-80 min'

          },

          notes: 'Very easy pace'

        },
        friday: {

          type: 'Rest',

          description: 'Complete rest day',

          intensity: 'Rest',

          metrics: {

            duration: '0 min'

          },

          notes: 'Recovery and preparation for long run'

        },
        saturday: {

          type: 'Long Run',

          description: 'Long slow distance run - Zone 2 effort',

          intensity: 'Moderate',

          metrics: {

            distance: '32km',

            pace: '6:15-6:45/km',

            duration: '170-175 min'

          },

          notes: 'Build endurance'

        },
        sunday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 1-2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '9km',

            pace: '6:30-7:00/km',

            duration: '50-55 min'

          },

          notes: 'Very easy pace'

        }
      },
      {
        week: 13,
        focus: 'Endurance Building',
        totalDistance: '95km',
        monday: {

          type: 'Rest/Cross-Training',

          description: 'Active recovery or cross-training',

          intensity: 'Recovery',

          metrics: {

            duration: '30-45 min'

          },

          notes: 'Swimming'

        },
        tuesday: {

          type: 'Easy Run',

          description: 'Easy pace run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '18km',

            pace: '6:00-6:30/km',

            duration: '95-100 min'

          },

          notes: 'Conversational pace'

        },
        wednesday: {

          type: 'Tempo Run',

          description: '45 min tempo at half marathon pace',

          intensity: 'Hard',

          metrics: {

            distance: '18km',

            pace: '5:30-6:00/km',

            duration: '90-95 min'

          },

          notes: 'Include 10 min warm-up and cool-down'

        },
        thursday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '16km',

            pace: '6:00-6:30/km',

            duration: '85-90 min'

          },

          notes: 'Very easy pace'

        },
        friday: {

          type: 'Rest',

          description: 'Complete rest day',

          intensity: 'Rest',

          metrics: {

            duration: '0 min'

          },

          notes: 'Recovery and preparation for long run'

        },
        saturday: {

          type: 'Long Run',

          description: 'Long slow distance run - Zone 2 effort',

          intensity: 'Moderate',

          metrics: {

            distance: '34km',

            pace: '6:15-6:45/km',

            duration: '180-185 min'

          },

          notes: 'Build endurance'

        },
        sunday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 1-2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '10km',

            pace: '6:30-7:00/km',

            duration: '55-60 min'

          },

          notes: 'Very easy pace'

        }
      },
      {
        week: 14,
        focus: 'Endurance Building',
        totalDistance: '100km',
        monday: {

          type: 'Rest/Cross-Training',

          description: 'Active recovery or cross-training',

          intensity: 'Recovery',

          metrics: {

            duration: '30-45 min'

          },

          notes: 'Swimming'
        },
        tuesday: {

          type: 'Easy Run',

          description: 'Easy pace run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '18km',

            pace: '6:00-6:30/km',

            duration: '95-100 min'

          },

          notes: 'Conversational pace'
        },
        wednesday: {

          type: 'Interval',

          description: '16x800m intervals with 2 min rest',

          intensity: 'Hard',

          metrics: {

            distance: '18km',

            pace: '4:30-5:00/km',

            duration: '90-95 min'

          },

          notes: 'Focus on form'

        },
        thursday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '16km',

            pace: '6:00-6:30/km',

            duration: '85-90 min'

          },

          notes: 'Very easy pace'

        },
        friday: {

          type: 'Rest',

          description: 'Complete rest day',

          intensity: 'Rest',

          metrics: {

            duration: '0 min'

          },

          notes: 'Recovery and preparation for long run'

        },
        saturday: {

          type: 'Long Run',

          description: 'Long slow distance run - Zone 2 effort',

          intensity: 'Moderate',

          metrics: {

            distance: '36km',

            pace: '6:15-6:45/km',

            duration: '190-195 min'

          },

          notes: 'Build endurance'

        },
        sunday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 1-2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '10km',

            pace: '6:30-7:00/km',

            duration: '55-60 min'

          },

          notes: 'Very easy pace'

        }
      },
      {
        week: 15,
        focus: 'Tapering',
        totalDistance: '70km',
        monday: {

          type: 'Rest/Cross-Training',

          description: 'Active recovery or cross-training',

          intensity: 'Recovery',

          metrics: {

            duration: '30-45 min'

          },

          notes: 'Swimming'

        },
        tuesday: {

          type: 'Easy Run',

          description: 'Easy pace run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '12km',

            pace: '6:00-6:30/km',

            duration: '65-70 min'

          },

          notes: 'Conversational pace'
        },
        wednesday: {

          type: 'Tempo Run',

          description: '20 min tempo at half marathon pace',

          intensity: 'Moderate',

          metrics: {

            distance: '10km',

            pace: '5:30-6:00/km',

            duration: '50-55 min'

          },

          notes: 'Include 10 min warm-up and cool-down'

        },
        thursday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '10km',

            pace: '6:00-6:30/km',

            duration: '55-60 min'

          },

          notes: 'Very easy pace'

        },
        friday: {

          type: 'Rest',

          description: 'Complete rest day',

          intensity: 'Rest',

          metrics: {

            duration: '0 min'

          },

          notes: 'Recovery and preparation for long run'

        },
        saturday: {

          type: 'Long Run',

          description: 'Long slow distance run - Zone 2 effort',

          intensity: 'Moderate',

          metrics: {

            distance: '20km',

            pace: '6:15-6:45/km',

            duration: '110-115 min'

          },

          notes: 'Final long run'

        },
        sunday: {

          type: 'Easy Run',

          description: 'Recovery run - Zone 1-2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '8km',

            pace: '6:30-7:00/km',

            duration: '45-50 min'

          },

          notes: 'Very easy pace'

        }
      },
      {
        week: 16,
        focus: 'Race Week',
        totalDistance: '30km',
        monday: {

          type: 'Easy Run',

          description: 'Very easy pace run',

          intensity: 'Easy',

          metrics: {

            distance: '5km',

            pace: '6:30-7:00/km',

            duration: '30-35 min'

          },

          notes: 'Very easy pace'

        },
        tuesday: {

          type: 'Easy Run',

          description: 'Easy pace run - Zone 2 effort',

          intensity: 'Easy',

          metrics: {

            distance: '6km',

            pace: '6:00-6:30/km',

            duration: '35-40 min'

          },

          notes: 'Conversational pace'

        },
        wednesday: {

          type: 'Easy Run',

          description: 'Very easy pace run',

          intensity: 'Easy',

          metrics: {

            distance: '4km',

            pace: '6:30-7:00/km',

            duration: '25-30 min'

          },

          notes: 'Very easy pace'

        },
        thursday: {

          type: 'Rest',

          description: 'Complete rest day',

          intensity: 'Rest',

          metrics: {

            duration: '0 min'

          },

          notes: 'Recovery and preparation for race'

        },
        friday: {

          type: 'Easy Run',

          description: 'Very easy pace run',

          intensity: 'Easy',

          metrics: {

            distance: '3km',

            pace: '6:30-7:00/km',

            duration: '20-25 min'

          },

          notes: 'Very easy pace'

        },
        saturday: {

          type: 'Rest',

          description: 'Complete rest day',

          intensity: 'Rest',

          metrics: {

            duration: '0 min'

          },

          notes: 'Rest and prepare for race day'

        },
        sunday: {

          type: 'Race Day',

          description: 'Marathon Race',

          intensity: 'Race',

          metrics: {

            distance: '42.2km',

            pace: 'Race pace',

            duration: '3:30-5:00'

          },

          notes: 'Race day! Trust your training and enjoy the experience'

        }
      }
    ]
  }
]

export const trainingZones = {
  zone1: {
    name: 'Zone 1 - Recovery',
    description: 'Very easy pace, active recovery',
    pace: '6:30-7:00/km',
    heartRate: '60-70% of max HR',
    effort: 'Very easy, conversational'
  },
  zone2: {
    name: 'Zone 2 - Aerobic',
    description: 'Easy pace, building aerobic base',
    pace: '6:00-6:30/km',
    heartRate: '70-80% of max HR',
    effort: 'Easy, can hold conversation'
  },
  zone3: {
    name: 'Zone 3 - Tempo',
    description: 'Moderate pace, lactate threshold',
    pace: '5:30-6:00/km',
    heartRate: '80-90% of max HR',
    effort: 'Moderate, can speak in short sentences'
  },
  zone4: {
    name: 'Zone 4 - Threshold',
    description: 'Hard pace, improving lactate threshold',
    pace: '5:00-5:30/km',
    heartRate: '90-95% of max HR',
    effort: 'Hard, difficult to speak'
  },
  zone5: {
    name: 'Zone 5 - VO2 Max',
    description: 'Very hard pace, improving VO2 max',
    pace: '4:30-5:00/km',
    heartRate: '95-100% of max HR',
    effort: 'Very hard, cannot speak'
  }
}
